export const monacoEditorSqlKeywords = [
  {
    label: 'ABORT',
    documentation:
      'Ends a transaction and rolls back any changes made during the transaction. Example: ABORT;',
    insertText: 'ABORT',
    detail: 'ABORT',
  },
  {
    label: 'ABS',
    documentation:
      'Returns the absolute value of a numeric expression. Example: ABS(-5) returns 5.',
    insertText: 'ABS',
    detail: 'ABS(expression)',
  },
  {
    label: 'ACTION',
    documentation:
      'Defines an action to be taken. Example may vary based on the SQL context. Example: CREATE TRIGGER trigger_name BEFORE INSERT ON table_name FOR EACH ROW BEGIN ACTION END;',
    insertText: 'ACTION',
    detail: 'ACTION',
  },
  {
    label: 'ADA',
    documentation:
      'Refers to the ADA programming language, often used in database systems for writing stored procedures or functions. Example: CREATE FUNCTION ada_function() RETURNS void AS $$ ADA code $$ LANGUAGE ada;',
    insertText: 'ADA',
    detail: 'ADA',
  },
  {
    label: 'ADD',
    documentation:
      'Adds a column to an existing table. Example: ALTER TABLE table_name ADD column_name INT;',
    insertText: 'ADD',
    detail: 'ADD',
  },
  {
    label: 'AFTER',
    documentation:
      'Specifies when a trigger should be executed relative to the triggering event. Example: CREATE TRIGGER trigger_name AFTER INSERT ON table_name FOR EACH ROW BEGIN action END;',
    insertText: 'AFTER',
    detail: 'AFTER',
  },
  {
    label: 'ALL',
    documentation:
      'Used to select all records that meet the criteria. Example: SELECT * FROM table_name WHERE column_name = ALL (SELECT column_name FROM another_table);',
    insertText: 'ALL',
    detail: 'ALL',
  },
  {
    label: 'ALLOCATE',
    documentation:
      'Allocates a dynamic SQL cursor. Example: ALLOCATE cursor_name CURSOR FOR PREPARED statement_name;',
    insertText: 'ALLOCATE',
    detail: 'ALLOCATE',
  },
  {
    label: 'ALTER',
    documentation:
      'Modifies an existing database object, such as a table. Example: ALTER TABLE table_name ADD column_name INT;',
    insertText: 'ALTER',
    detail: 'ALTER',
  },
  {
    label: 'ALWAYS',
    documentation:
      'Defines a column that always generates its value automatically. Example: CREATE TABLE table_name (column_name INT GENERATED ALWAYS AS IDENTITY);',
    insertText: 'ALWAYS',
    detail: 'ALWAYS',
  },
  {
    label: 'ANALYZE',
    documentation:
      'Collects statistics about the contents of tables in the database. Example: ANALYZE table_name;',
    insertText: 'ANALYZE',
    detail: 'ANALYZE',
  },
  {
    label: 'AND',
    documentation:
      'Combines multiple conditions in a WHERE clause. Example: SELECT * FROM table_name WHERE column1 = value1 AND column2 = value2;',
    insertText: 'AND',
    detail: 'AND',
  },
  {
    label: 'ANY',
    documentation:
      'Compares a value to any value in a list or subquery. Example: SELECT * FROM table_name WHERE column_name = ANY (SELECT column_name FROM another_table);',
    insertText: 'ANY',
    detail: 'ANY',
  },
  {
    label: 'ARE',
    documentation:
      'Used in SQL procedural languages to assign values. Example: SET variable_name = value;',
    insertText: 'ARE',
    detail: 'ARE',
  },
  {
    label: 'AS',
    documentation:
      'Renames a column or table with an alias. Example: SELECT column_name AS alias_name FROM table_name;',
    insertText: 'AS',
    detail: 'AS',
  },
  {
    label: 'ASC',
    documentation:
      'Sorts the result set in ascending order. Example: SELECT * FROM table_name ORDER BY column_name ASC;',
    insertText: 'ASC',
    detail: 'ASC',
  },
  {
    label: 'ASSERTION',
    documentation:
      'Defines a condition that must be true for the database to be in a valid state. Example: CREATE ASSERTION assertion_name CHECK (condition);',
    insertText: 'ASSERTION',
    detail: 'ASSERTION',
  },
  {
    label: 'AT',
    documentation:
      'Specifies a precise location or time. Example: FETCH ABSOLUTE 5 IN cursor_name;',
    insertText: 'AT',
    detail: 'AT',
  },
  {
    label: 'ATTACH',
    documentation:
      "Attaches a database file to the current database connection. Example: ATTACH DATABASE 'filename' AS dbname;",
    insertText: 'ATTACH',
    detail: 'ATTACH',
  },
  {
    label: 'AUTHORIZATION',
    documentation:
      'Specifies the owner of a schema or database. Example: CREATE SCHEMA schema_name AUTHORIZATION user_name;',
    insertText: 'AUTHORIZATION',
    detail: 'AUTHORIZATION',
  },
  {
    label: 'AUTOINCREMENT',
    documentation:
      'Automatically generates a unique value for a column whenever a new row is inserted. Example: CREATE TABLE table_name (id INTEGER PRIMARY KEY AUTOINCREMENT);',
    insertText: 'AUTOINCREMENT',
    detail: 'AUTOINCREMENT',
  },
  {
    label: 'AVG',
    documentation:
      'Calculates the average value of a numeric column. Example: SELECT AVG(column_name) FROM table_name;',
    insertText: 'AVG',
    detail: 'AVG(expression)',
  },
  {
    label: 'BACKUP',
    documentation:
      "Creates a backup of the database. Example: BACKUP DATABASE dbname TO DISK = 'path';",
    insertText: 'BACKUP',
    detail: 'BACKUP',
  },
  {
    label: 'BEFORE',
    documentation:
      'Specifies when a trigger should be executed relative to the triggering event. Example: CREATE TRIGGER trigger_name BEFORE INSERT ON table_name FOR EACH ROW BEGIN action END;',
    insertText: 'BEFORE',
    detail: 'BEFORE',
  },
  {
    label: 'BEGIN',
    documentation: 'Starts a transaction. Example: BEGIN TRANSACTION;',
    insertText: 'BEGIN',
    detail: 'BEGIN',
  },
  {
    label: 'BETWEEN',
    documentation:
      'Filters the result set within a certain range. Example: SELECT * FROM table_name WHERE column_name BETWEEN value1 AND value2;',
    insertText: 'BETWEEN',
    detail: 'BETWEEN',
  },
  {
    label: 'BIT',
    documentation:
      'Stores a bit (0 or 1). Example: CREATE TABLE table_name (column_name BIT);',
    insertText: 'BIT',
    detail: 'BIT',
  },
  {
    label: 'BIT_LENGTH',
    documentation:
      "Returns the number of bits in an expression. Example: SELECT BIT_LENGTH('A') FROM table_name;",
    insertText: 'BIT_LENGTH',
    detail: 'BIT_LENGTH(expression)',
  },
  {
    label: 'BOTH',
    documentation:
      "Used with the TRIM function to remove characters from both ends of a string. Example: SELECT TRIM(BOTH ' ' FROM column_name) FROM table_name;",
    insertText: 'BOTH',
    detail: 'BOTH',
  },
  {
    label: 'BREAK',
    documentation:
      'Exits a loop or switch statement. Example: WHILE condition BREAK;',
    insertText: 'BREAK',
    detail: 'BREAK',
  },
  {
    label: 'BROWSE',
    documentation:
      'Used to display data in a user-friendly format. Example: BROWSE table_name;',
    insertText: 'BROWSE',
    detail: 'BROWSE',
  },
  {
    label: 'BULK',
    documentation:
      "Performs a bulk insert of data from a file into a table. Example: BULK INSERT table_name FROM 'file_path' WITH (FIELDTERMINATOR = ',', ROWTERMINATOR = '\\n');",
    insertText: 'BULK',
    detail: 'BULK',
  },
  {
    label: 'BY',
    documentation:
      'Used in conjunction with GROUP to specify grouping columns. Example: SELECT column_name, COUNT(*) FROM table_name GROUP BY column_name;',
    insertText: 'BY',
    detail: 'BY',
  },
  {
    label: 'CASCADE',
    documentation:
      'Specifies that an action should be propagated to dependent objects. Example: DROP TABLE table_name CASCADE;',
    insertText: 'CASCADE',
    detail: 'CASCADE',
  },
  {
    label: 'CASCADED',
    documentation:
      'Specifies that an action should be propagated to dependent objects. Example: REVOKE ALL PRIVILEGES ON table_name FROM user_name CASCADE;',
    insertText: 'CASCADED',
    detail: 'CASCADED',
  },
  {
    label: 'CASE',
    documentation:
      'Evaluates a list of conditions and returns one of multiple possible result expressions. Example: SELECT CASE WHEN condition1 THEN result1 WHEN condition2 THEN result2 ELSE result3 END FROM table_name;',
    insertText: 'CASE',
    detail: 'CASE',
  },
  {
    label: 'CAST',
    documentation:
      'Converts a value from one data type to another. Example: SELECT CAST(column_name AS CHAR) FROM table_name;',
    insertText: 'CAST',
    detail: 'CAST(expression AS data_type)',
  },
  {
    label: 'CATALOG',
    documentation:
      'Refers to the database catalog or schema. Example: SELECT * FROM information_schema.catalog_name;',
    insertText: 'CATALOG',
    detail: 'CATALOG',
  },
  {
    label: 'CHAR',
    documentation:
      'Defines a fixed-length character string. Example: CREATE TABLE table_name (column_name CHAR(10));',
    insertText: 'CHAR',
    detail: 'CHAR(length)',
  },
  {
    label: 'CHARACTER',
    documentation:
      'Defines a fixed-length character string. Example: CREATE TABLE table_name (column_name CHARACTER(10));',
    insertText: 'CHARACTER',
    detail: 'CHARACTER(length)',
  },
  {
    label: 'CHARACTER_LENGTH',
    documentation:
      'Returns the length of a character string. Example: SELECT CHARACTER_LENGTH(column_name) FROM table_name;',
    insertText: 'CHARACTER_LENGTH',
    detail: 'CHARACTER_LENGTH(expression)',
  },
  {
    label: 'CHAR_LENGTH',
    documentation:
      'Returns the length of a character string. Example: SELECT CHAR_LENGTH(column_name) FROM table_name;',
    insertText: 'CHAR_LENGTH',
    detail: 'CHAR_LENGTH(expression)',
  },
  {
    label: 'CHECK',
    documentation:
      'Adds a condition that must be met for a record to be added to the table. Example: CREATE TABLE table_name (column_name INT CHECK (column_name > 0));',
    insertText: 'CHECK',
    detail: 'CHECK',
  },
  {
    label: 'CHECKPOINT',
    documentation:
      'Saves the current state of the database. Example: CHECKPOINT;',
    insertText: 'CHECKPOINT',
    detail: 'CHECKPOINT',
  },
  {
    label: 'CLOSE',
    documentation: 'Closes an open cursor. Example: CLOSE cursor_name;',
    insertText: 'CLOSE',
    detail: 'CLOSE',
  },
  {
    label: 'CLUSTERED',
    documentation:
      'Defines a clustered index on a table. Example: CREATE CLUSTERED INDEX index_name ON table_name (column_name);',
    insertText: 'CLUSTERED',
    detail: 'CLUSTERED',
  },
  {
    label: 'COALESCE',
    documentation:
      "Returns the first non-null value from a list of expressions. Example: COALESCE(column1, column2, 'default') returns column1 if it's not null, otherwise column2, and if both are null, it returns 'default'.",
    insertText: 'COALESCE',
    detail: 'COALESCE(val1, val2, ..., val_n)',
  },
  {
    label: 'COLLATE',
    documentation:
      'Specifies the collation to be used for character data. Example: SELECT * FROM table_name ORDER BY column_name COLLATE collation_name;',
    insertText: 'COLLATE',
    detail: 'COLLATE',
  },
  {
    label: 'COLLATION',
    documentation:
      'Specifies the collation for a database, table, or column. Example: CREATE TABLE table_name (column_name VARCHAR(255) COLLATE collation_name);',
    insertText: 'COLLATION',
    detail: 'COLLATION',
  },
  {
    label: 'COLUMN',
    documentation:
      'Defines a column in a table. Example: CREATE TABLE table_name (column_name data_type);',
    insertText: 'COLUMN',
    detail: 'COLUMN',
  },
  {
    label: 'COMMIT',
    documentation:
      'Saves all the transactions to the database. Example: COMMIT;',
    insertText: 'COMMIT',
    detail: 'COMMIT',
  },
  {
    label: 'COMPUTE',
    documentation:
      'Calculates a summary value. Example: SELECT column_name, SUM(column_name) FROM table_name GROUP BY column_name COMPUTE SUM(column_name);',
    insertText: 'COMPUTE',
    detail: 'COMPUTE',
  },
  {
    label: 'CONFLICT',
    documentation:
      'Handles conflicts during an insert or update operation. Example: INSERT INTO table_name (column1, column2) VALUES (value1, value2) ON CONFLICT (column1) DO UPDATE SET column2 = excluded.column2;',
    insertText: 'CONFLICT',
    detail: 'CONFLICT',
  },
  {
    label: 'CONNECT',
    documentation:
      'Establishes a connection to the database. Example: CONNECT TO database_name;',
    insertText: 'CONNECT',
    detail: 'CONNECT',
  },
  {
    label: 'CONNECTION',
    documentation:
      'Refers to the database connection. Example: SET CONNECTION connection_name;',
    insertText: 'CONNECTION',
    detail: 'CONNECTION',
  },
  {
    label: 'CONSTRAINT',
    documentation:
      'Defines a rule to enforce on data in a table. Example: CREATE TABLE table_name (column_name INT, CONSTRAINT constraint_name PRIMARY KEY (column_name));',
    insertText: 'CONSTRAINT',
    detail: 'CONSTRAINT',
  },
  {
    label: 'CONSTRAINTS',
    documentation:
      'Defines rules to enforce on data in tables. Example: ALTER TABLE table_name ADD CONSTRAINT constraint_name CHECK (condition);',
    insertText: 'CONSTRAINTS',
    detail: 'CONSTRAINTS',
  },
  {
    label: 'CONTAINS',
    documentation:
      "Performs a full-text search for a specified text in a column. Example: SELECT * FROM table_name WHERE CONTAINS(column_name, 'text');",
    insertText: 'CONTAINS',
    detail: "CONTAINS(column, 'text')",
  },
  {
    label: 'CONTAINSTABLE',
    documentation:
      "Returns a table of full-text indexed rows that match the specified text. Example: SELECT * FROM CONTAINSTABLE(table_name, column_name, 'text');",
    insertText: 'CONTAINSTABLE',
    detail: "CONTAINSTABLE(table, column, 'text')",
  },
  {
    label: 'CONTINUE',
    documentation:
      'Skips the current iteration of a loop and proceeds with the next iteration. Example: WHILE condition CONTINUE;',
    insertText: 'CONTINUE',
    detail: 'CONTINUE',
  },
  {
    label: 'CONVERT',
    documentation:
      'Converts a value from one data type to another. Example: SELECT CONVERT(VARCHAR, column_name) FROM table_name;',
    insertText: 'CONVERT',
    detail: 'CONVERT(data_type, expression)',
  },
  {
    label: 'CORRESPONDING',
    documentation:
      'Used with a set operation to specify matching columns. Example: SELECT * FROM table1 CORRESPONDING SELECT * FROM table2;',
    insertText: 'CORRESPONDING',
    detail: 'CORRESPONDING',
  },
  {
    label: 'COUNT',
    documentation:
      'Returns the number of rows that match a specified condition. Example: SELECT COUNT(*) FROM table_name;',
    insertText: 'COUNT',
    detail: 'COUNT(expression)',
  },
  {
    label: 'CREATE',
    documentation:
      'Creates a new database object, such as a table, view, or index. Example: CREATE TABLE table_name (column1 datatype, column2 datatype);',
    insertText: 'CREATE',
    detail: 'CREATE',
  },
  {
    label: 'CROSS',
    documentation:
      'Performs a cross join between two tables. Example: SELECT * FROM table1 CROSS JOIN table2;',
    insertText: 'CROSS',
    detail: 'CROSS',
  },
  {
    label: 'CURRENT',
    documentation:
      'Refers to the current value of a cursor. Example: FETCH CURRENT FROM cursor_name;',
    insertText: 'CURRENT',
    detail: 'CURRENT',
  },
  {
    label: 'CURRENT_DATE',
    documentation: 'Returns the current date. Example: SELECT CURRENT_DATE;',
    insertText: 'CURRENT_DATE',
    detail: 'CURRENT_DATE',
  },
  {
    label: 'CURRENT_TIME',
    documentation: 'Returns the current time. Example: SELECT CURRENT_TIME;',
    insertText: 'CURRENT_TIME',
    detail: 'CURRENT_TIME',
  },
  {
    label: 'CURRENT_TIMESTAMP',
    documentation:
      'Returns the current date and time. Example: SELECT CURRENT_TIMESTAMP;',
    insertText: 'CURRENT_TIMESTAMP',
    detail: 'CURRENT_TIMESTAMP',
  },
  {
    label: 'CURRENT_USER',
    documentation:
      'Returns the name of the current user. Example: SELECT CURRENT_USER;',
    insertText: 'CURRENT_USER',
    detail: 'CURRENT_USER',
  },
  {
    label: 'CURSOR',
    documentation:
      'Declares a cursor for a set of rows. Example: DECLARE cursor_name CURSOR FOR SELECT column_name FROM table_name;',
    insertText: 'CURSOR',
    detail: 'CURSOR',
  },
  {
    label: 'DATABASE',
    documentation:
      'Refers to the database. Example: CREATE DATABASE database_name;',
    insertText: 'DATABASE',
    detail: 'DATABASE',
  },
  {
    label: 'DATE',
    documentation:
      'Stores a date value. Example: CREATE TABLE table_name (column_name DATE);',
    insertText: 'DATE',
    detail: 'DATE',
  },
  {
    label: 'DAY',
    documentation:
      'Extracts the day part of a date. Example: SELECT DAY(date_column) FROM table_name;',
    insertText: 'DAY',
    detail: 'DAY',
  },
  {
    label: 'DBCC',
    documentation: 'Performs database console commands. Example: DBCC CHECKDB;',
    insertText: 'DBCC',
    detail: 'DBCC',
  },
  {
    label: 'DEALLOCATE',
    documentation: 'Deallocates a cursor. Example: DEALLOCATE cursor_name;',
    insertText: 'DEALLOCATE',
    detail: 'DEALLOCATE',
  },
  {
    label: 'DEC',
    documentation:
      'A synonym for DECIMAL. Example: CREATE TABLE table_name (column_name DEC);',
    insertText: 'DEC',
    detail: 'DEC',
  },
  {
    label: 'DECIMAL',
    documentation:
      'Defines a decimal number. Example: CREATE TABLE table_name (column_name DECIMAL(10, 2));',
    insertText: 'DECIMAL',
    detail: 'DECIMAL(precision, scale)',
  },
  {
    label: 'DECLARE',
    documentation:
      'Declares a variable, cursor, or condition. Example: DECLARE @variable_name INT;',
    insertText: 'DECLARE',
    detail: 'DECLARE',
  },
  {
    label: 'DEFAULT',
    documentation:
      'Specifies a default value for a column. Example: CREATE TABLE table_name (column_name INT DEFAULT 0);',
    insertText: 'DEFAULT',
    detail: 'DEFAULT',
  },
  {
    label: 'DEFERRABLE',
    documentation:
      'Specifies that a constraint can be deferred. Example: CREATE TABLE table_name (column_name INT CONSTRAINT constraint_name DEFERRABLE);',
    insertText: 'DEFERRABLE',
    detail: 'DEFERRABLE',
  },
  {
    label: 'DEFERRED',
    documentation:
      'Specifies that a constraint is deferred until the end of the transaction. Example: SET CONSTRAINTS constraint_name DEFERRED;',
    insertText: 'DEFERRED',
    detail: 'DEFERRED',
  },
  {
    label: 'DELETE',
    documentation:
      'Deletes rows from a table. Example: DELETE FROM table_name WHERE condition;',
    insertText: 'DELETE',
    detail: 'DELETE',
  },
  {
    label: 'DENY',
    documentation:
      'Denies a permission to a user or role. Example: DENY SELECT ON table_name TO user_name;',
    insertText: 'DENY',
    detail: 'DENY',
  },
  {
    label: 'DESC',
    documentation:
      'Sorts the result set in descending order. Example: SELECT * FROM table_name ORDER BY column_name DESC;',
    insertText: 'DESC',
    detail: 'DESC',
  },
  {
    label: 'DESCRIBE',
    documentation:
      'Describes the structure of a table. Example: DESCRIBE table_name;',
    insertText: 'DESCRIBE',
    detail: 'DESCRIBE',
  },
  {
    label: 'DESCRIPTOR',
    documentation:
      'Refers to SQL descriptors. Example: ALLOCATE DESCRIPTOR descriptor_name;',
    insertText: 'DESCRIPTOR',
    detail: 'DESCRIPTOR',
  },
  {
    label: 'DETACH',
    documentation:
      'Detaches a database file from the current database connection. Example: DETACH DATABASE dbname;',
    insertText: 'DETACH',
    detail: 'DETACH',
  },
  {
    label: 'DIAGNOSTICS',
    documentation:
      'Provides diagnostic information about SQL statements. Example: GET DIAGNOSTICS;',
    insertText: 'DIAGNOSTICS',
    detail: 'DIAGNOSTICS',
  },
  {
    label: 'DISCONNECT',
    documentation: 'Disconnects from the database. Example: DISCONNECT;',
    insertText: 'DISCONNECT',
    detail: 'DISCONNECT',
  },
  {
    label: 'DISK',
    documentation: 'Refers to disk storage operations. Example: DISK INIT;',
    insertText: 'DISK',
    detail: 'DISK',
  },
  {
    label: 'DISTINCT',
    documentation:
      'Selects only distinct (different) values. Example: SELECT DISTINCT column_name FROM table_name;',
    insertText: 'DISTINCT',
    detail: 'DISTINCT',
  },
  {
    label: 'DISTRIBUTED',
    documentation:
      'Refers to distributed transactions or databases. Example: BEGIN DISTRIBUTED TRANSACTION;',
    insertText: 'DISTRIBUTED',
    detail: 'DISTRIBUTED',
  },
  {
    label: 'DO',
    documentation:
      'Executes a set of statements. Example: DO $$ BEGIN statement; END $$;',
    insertText: 'DO',
    detail: 'DO',
  },
  {
    label: 'DOMAIN',
    documentation:
      'Defines a domain, which is a data type with constraints. Example: CREATE DOMAIN domain_name AS data_type CHECK (condition);',
    insertText: 'DOMAIN',
    detail: 'DOMAIN',
  },
  {
    label: 'DOUBLE',
    documentation:
      'Defines a double precision floating-point number. Example: CREATE TABLE table_name (column_name DOUBLE PRECISION);',
    insertText: 'DOUBLE',
    detail: 'DOUBLE PRECISION',
  },
  {
    label: 'DROP',
    documentation:
      'Deletes an existing database object, such as a table, view, or index. Example: DROP TABLE table_name;',
    insertText: 'DROP',
    detail: 'DROP',
  },
  {
    label: 'DUMP',
    documentation:
      "Creates a dump of the database. Example: DUMP DATABASE dbname TO 'path';",
    insertText: 'DUMP',
    detail: 'DUMP',
  },
  {
    label: 'EACH',
    documentation:
      'Used in looping constructs to iterate through a collection. Example: FOR EACH row IN cursor_name LOOP ... END LOOP;',
    insertText: 'EACH',
    detail: 'EACH',
  },
  {
    label: 'ELSE',
    documentation:
      'Specifies the alternative action if the condition in an IF statement is false. Example: IF condition THEN action1 ELSE action2 END IF;',
    insertText: 'ELSE',
    detail: 'ELSE',
  },
  {
    label: 'END',
    documentation: 'Marks the end of a control block. Example: BEGIN ... END;',
    insertText: 'END',
    detail: 'END',
  },
  {
    label: 'END-EXEC',
    documentation:
      'Marks the end of an embedded SQL statement in some SQL dialects. Example: EXEC SQL BEGIN DECLARE SECTION ... END-EXEC;',
    insertText: 'END-EXEC',
    detail: 'END-EXEC',
  },
  {
    label: 'ERRLVL',
    documentation:
      "Raises an error with a specified severity level. Example: RAISERROR('Error message', 16, 1) WITH SETERROR, SET ERRLVL 10;",
    insertText: 'ERRLVL',
    detail: 'ERRLVL',
  },
  {
    label: 'ESCAPE',
    documentation:
      "Specifies the escape character in a LIKE clause. Example: SELECT * FROM table_name WHERE column_name LIKE 'A!%' ESCAPE '!';",
    insertText: 'ESCAPE',
    detail: 'ESCAPE',
  },
  {
    label: 'EXCEPT',
    documentation:
      'Returns the difference between two result sets. Example: SELECT * FROM table1 EXCEPT SELECT * FROM table2;',
    insertText: 'EXCEPT',
    detail: 'EXCEPT',
  },
  {
    label: 'EXCEPTION',
    documentation:
      'Handles exceptions in SQL procedural code. Example: BEGIN ... EXCEPTION WHEN ... THEN ... END;',
    insertText: 'EXCEPTION',
    detail: 'EXCEPTION',
  },
  {
    label: 'EXCLUDE',
    documentation:
      'Excludes specified rows from a windowing function. Example: SELECT column_name, SUM(column_name) OVER (ORDER BY column_name EXCLUDE CURRENT ROW) FROM table_name;',
    insertText: 'EXCLUDE',
    detail: 'EXCLUDE',
  },
  {
    label: 'EXCLUSIVE',
    documentation:
      'Specifies exclusive access to a database or table. Example: LOCK TABLE table_name IN EXCLUSIVE MODE;',
    insertText: 'EXCLUSIVE',
    detail: 'EXCLUSIVE',
  },
  {
    label: 'EXEC',
    documentation:
      'Executes a stored procedure or dynamic SQL statement. Example: EXEC procedure_name;',
    insertText: 'EXEC',
    detail: 'EXEC',
  },
  {
    label: 'EXECUTE',
    documentation:
      'Executes a stored procedure or dynamic SQL statement. Example: EXECUTE procedure_name;',
    insertText: 'EXECUTE',
    detail: 'EXECUTE',
  },
  {
    label: 'EXISTS',
    documentation:
      'Checks for the existence of rows in a subquery. Example: SELECT * FROM table_name WHERE EXISTS (SELECT 1 FROM another_table WHERE condition);',
    insertText: 'EXISTS',
    detail: 'EXISTS',
  },
  {
    label: 'EXIT',
    documentation:
      'Exits from a loop or block. Example: LOOP ... EXIT WHEN condition; ... END LOOP;',
    insertText: 'EXIT',
    detail: 'EXIT',
  },
  {
    label: 'EXPLAIN',
    documentation:
      'Provides information about how SQL statements are executed. Example: EXPLAIN SELECT * FROM table_name;',
    insertText: 'EXPLAIN',
    detail: 'EXPLAIN',
  },
  {
    label: 'EXTERNAL',
    documentation:
      'Refers to external data sources or procedures. Example: CREATE EXTERNAL TABLE table_name (column_name data_type);',
    insertText: 'EXTERNAL',
    detail: 'EXTERNAL',
  },
  {
    label: 'EXTRACT',
    documentation:
      'Extracts a part of a date or time. Example: SELECT EXTRACT(YEAR FROM date_column) FROM table_name;',
    insertText: 'EXTRACT',
    detail: 'EXTRACT(field FROM source)',
  },
  {
    label: 'FAIL',
    documentation:
      'Causes a transaction to fail. Example: INSERT INTO table_name (column_name) VALUES (value1) ON CONFLICT (column_name) DO NOTHING FAIL;',
    insertText: 'FAIL',
    detail: 'FAIL',
  },
  {
    label: 'FALSE',
    documentation:
      'Represents a boolean false value. Example: SELECT * FROM table_name WHERE column_name = FALSE;',
    insertText: 'FALSE',
    detail: 'FALSE',
  },
  {
    label: 'FETCH',
    documentation:
      'Retrieves rows using a cursor. Example: FETCH NEXT FROM cursor_name;',
    insertText: 'FETCH',
    detail: 'FETCH',
  },
  {
    label: 'FILE',
    documentation:
      "Refers to file-related operations. Example: CREATE DATABASE database_name ON PRIMARY (NAME = 'database_data', FILENAME = 'path_to_file');",
    insertText: 'FILE',
    detail: 'FILE',
  },
  {
    label: 'FILLFACTOR',
    documentation:
      'Sets the fill factor for an index. Example: CREATE INDEX index_name ON table_name (column_name) WITH (FILLFACTOR = 70);',
    insertText: 'FILLFACTOR',
    detail: 'FILLFACTOR',
  },
  {
    label: 'FILTER',
    documentation:
      'Filters rows before applying an aggregate function. Example: SELECT COUNT(*) FILTER (WHERE condition) FROM table_name;',
    insertText: 'FILTER',
    detail: 'FILTER',
  },
  {
    label: 'FIRST',
    documentation:
      'Returns the first value in a set of values. Example: SELECT FIRST(column_name) FROM table_name;',
    insertText: 'FIRST',
    detail: 'FIRST',
  },
  {
    label: 'FLOAT',
    documentation:
      'Defines a floating-point number. Example: CREATE TABLE table_name (column_name FLOAT);',
    insertText: 'FLOAT',
    detail: 'FLOAT',
  },
  {
    label: 'FOLLOWING',
    documentation:
      'Specifies the number of rows to follow the current row in a window function. Example: SELECT SUM(column_name) OVER (ROWS 1 FOLLOWING) FROM table_name;',
    insertText: 'FOLLOWING',
    detail: 'FOLLOWING',
  },
  {
    label: 'FOR',
    documentation:
      'Specifies the context for a cursor or loop. Example: FOR cursor_name IN (SELECT column_name FROM table_name) LOOP ... END LOOP;',
    insertText: 'FOR',
    detail: 'FOR',
  },
  {
    label: 'FOREIGN',
    documentation:
      'Defines a foreign key constraint. Example: CREATE TABLE table_name (column_name INT, FOREIGN KEY (column_name) REFERENCES another_table (column_name));',
    insertText: 'FOREIGN',
    detail: 'FOREIGN',
  },
  {
    label: 'FORTRAN',
    documentation:
      'Refers to the FORTRAN programming language, often used in database systems for writing stored procedures or functions. Example: CREATE FUNCTION fortran _function() RETURNS void AS $$ FORTRAN code $$ LANGUAGE fortran;',
    insertText: 'FORTRAN',
    detail: 'FORTRAN',
  },
  {
    label: 'FOUND',
    documentation:
      'Indicates whether a match was found in a SQL procedural code. Example: IF FOUND THEN ... END IF;',
    insertText: 'FOUND',
    detail: 'FOUND',
  },
  {
    label: 'FREETEXT',
    documentation:
      "Performs a full-text search based on the meaning of the text. Example: SELECT * FROM table_name WHERE FREETEXT(column_name, 'text');",
    insertText: 'FREETEXT',
    detail: "FREETEXT(column, 'text')",
  },
  {
    label: 'FREETEXTTABLE',
    documentation:
      "Returns a table of full-text indexed rows that match the meaning of the specified text. Example: SELECT * FROM FREETEXTTABLE(table_name, column_name, 'text');",
    insertText: 'FREETEXTTABLE',
    detail: "FREETEXTTABLE(table, column, 'text')",
  },
  {
    label: 'FROM',
    documentation:
      'Specifies the table(s) to retrieve data from in a SELECT statement. Example: SELECT * FROM table_name;',
    insertText: 'FROM',
    detail: 'FROM',
  },
  {
    label: 'FULL',
    documentation:
      'Specifies a full outer join between two tables. Example: SELECT * FROM table1 FULL JOIN table2 ON table1.column_name = table2.column_name;',
    insertText: 'FULL',
    detail: 'FULL',
  },
  {
    label: 'FUNCTION',
    documentation:
      'Creates a stored function. Example: CREATE FUNCTION function_name() RETURNS return_type AS $$ BEGIN ... END $$ LANGUAGE plpgsql;',
    insertText: 'FUNCTION',
    detail: 'FUNCTION',
  },
  {
    label: 'GENERATED',
    documentation:
      'Specifies that a column is generated automatically. Example: CREATE TABLE table_name (column_name INT GENERATED ALWAYS AS IDENTITY);',
    insertText: 'GENERATED',
    detail: 'GENERATED',
  },
  {
    label: 'GET',
    documentation:
      'Retrieves the value of a parameter or variable. Example: GET DIAGNOSTICS variable_name = condition_number;',
    insertText: 'GET',
    detail: 'GET',
  },
  {
    label: 'GLOB',
    documentation:
      "Performs a pattern matching using SQL's GLOB operator. Example: SELECT * FROM table_name WHERE column_name GLOB 'pattern';",
    insertText: 'GLOB',
    detail: 'GLOB',
  },
  {
    label: 'GLOBAL',
    documentation:
      'Defines a global temporary table or variable. Example: CREATE GLOBAL TEMPORARY TABLE table_name (column_name data_type);',
    insertText: 'GLOBAL',
    detail: 'GLOBAL',
  },
  {
    label: 'GO',
    documentation:
      'Signals the end of a batch of SQL statements to the SQL Server utilities. Example: CREATE TABLE table_name (column_name data_type); GO',
    insertText: 'GO',
    detail: 'GO',
  },
  {
    label: 'GOTO',
    documentation:
      'Transfers control to a labeled block. Example: GOTO label_name;',
    insertText: 'GOTO',
    detail: 'GOTO',
  },
  {
    label: 'GRANT',
    documentation:
      'Grants privileges on database objects. Example: GRANT SELECT ON table_name TO user_name;',
    insertText: 'GRANT',
    detail: 'GRANT',
  },
  {
    label: 'GROUP',
    documentation:
      'Groups rows that have the same values into summary rows. Example: SELECT column_name, COUNT(*) FROM table_name GROUP BY column_name;',
    insertText: 'GROUP',
    detail: 'GROUP',
  },
  {
    label: 'GROUPS',
    documentation:
      'Defines a number of groups for a window function. Example: SELECT column_name, SUM(column_name) OVER (GROUPS 1 PRECEDING) FROM table_name;',
    insertText: 'GROUPS',
    detail: 'GROUPS',
  },
  {
    label: 'HAVING',
    documentation:
      'Specifies a condition for groups created by the GROUP BY clause. Example: SELECT column_name, COUNT(*) FROM table_name GROUP BY column_name HAVING COUNT(*) > 1;',
    insertText: 'HAVING',
    detail: 'HAVING',
  },
  {
    label: 'HOLDLOCK',
    documentation:
      'Specifies that the shared locks are held until the transaction is completed. Example: SELECT * FROM table_name WITH (HOLDLOCK);',
    insertText: 'HOLDLOCK',
    detail: 'HOLDLOCK',
  },
  {
    label: 'HOUR',
    documentation:
      'Extracts the hour part of a time or timestamp. Example: SELECT HOUR(time_column) FROM table_name;',
    insertText: 'HOUR',
    detail: 'HOUR',
  },
  {
    label: 'IDENTITY',
    documentation:
      'Defines a column as an identity column. Example: CREATE TABLE table_name (column_name INT IDENTITY(1,1));',
    insertText: 'IDENTITY',
    detail: 'IDENTITY',
  },
  {
    label: 'IDENTITYCOL',
    documentation:
      'Refers to the identity column of a table. Example: SELECT IDENTITYCOL FROM table_name;',
    insertText: 'IDENTITYCOL',
    detail: 'IDENTITYCOL',
  },
  {
    label: 'IDENTITY_INSERT',
    documentation:
      'Allows explicit values to be inserted into the identity column of a table. Example: SET IDENTITY_INSERT table_name ON;',
    insertText: 'IDENTITY_INSERT',
    detail: 'IDENTITY_INSERT',
  },
  {
    label: 'IF',
    documentation:
      'Executes a set of SQL statements based on a condition. Example: IF condition BEGIN ... END;',
    insertText: 'IF',
    detail: 'IF',
  },
  {
    label: 'IGNORE',
    documentation:
      'Ignores errors in a set of SQL statements. Example: INSERT IGNORE INTO table_name (column_name) VALUES (value1);',
    insertText: 'IGNORE',
    detail: 'IGNORE',
  },
  {
    label: 'IMMEDIATE',
    documentation:
      'Executes an action immediately. Example: SET CONSTRAINTS ALL IMMEDIATE;',
    insertText: 'IMMEDIATE',
    detail: 'IMMEDIATE',
  },
  {
    label: 'IN',
    documentation:
      'Specifies a set of values for a column. Example: SELECT * FROM table_name WHERE column_name IN (value1, value2, value3);',
    insertText: 'IN',
    detail: 'IN',
  },
  {
    label: 'INCLUDE',
    documentation:
      'Includes additional columns in an index. Example: CREATE INDEX index_name ON table_name (column_name) INCLUDE (additional_column);',
    insertText: 'INCLUDE',
    detail: 'INCLUDE',
  },
  {
    label: 'INDEX',
    documentation:
      'Creates or refers to an index on a table. Example: CREATE INDEX index_name ON table_name (column_name);',
    insertText: 'INDEX',
    detail: 'INDEX',
  },
  {
    label: 'INDEXED',
    documentation:
      'Refers to a table that has indexes. Example: SELECT * FROM INDEXED table_name;',
    insertText: 'INDEXED',
    detail: 'INDEXED',
  },
  {
    label: 'INDICATOR',
    documentation:
      'Indicates the status of an SQL operation. Example: SELECT column_name INTO :variable INDICATOR :indicator FROM table_name;',
    insertText: 'INDICATOR',
    detail: 'INDICATOR',
  },
  {
    label: 'INITIALLY',
    documentation:
      'Specifies the initial state of a deferrable constraint. Example: CREATE TABLE table_name (column_name INT CONSTRAINT constraint_name DEFERRABLE INITIALLY DEFERRED);',
    insertText: 'INITIALLY',
    detail: 'INITIALLY',
  },
  {
    label: 'INNER',
    documentation:
      'Specifies an inner join between two tables. Example: SELECT * FROM table1 INNER JOIN table2 ON table1.column_name = table2.column_name;',
    insertText: 'INNER',
    detail: 'INNER',
  },
  {
    label: 'INPUT',
    documentation:
      'Specifies an input parameter for a procedure or function. Example: CREATE PROCEDURE procedure_name (INPUT parameter_name data_type) AS ...;',
    insertText: 'INPUT',
    detail: 'INPUT',
  },
  {
    label: 'INSENSITIVE',
    documentation:
      'Defines a cursor that is not sensitive to changes in the database. Example: DECLARE cursor_name INSENSITIVE CURSOR FOR SELECT column_name FROM table_name;',
    insertText: 'INSENSITIVE',
    detail: 'INSENSITIVE',
  },
  {
    label: 'INSERT',
    documentation:
      'Adds new rows to a table. Example: INSERT INTO table_name (column1, column2) VALUES (value1, value2);',
    insertText: 'INSERT',
    detail: 'INSERT',
  },
  {
    label: 'INSTEAD',
    documentation:
      'Defines an INSTEAD OF trigger to perform an action instead of the triggering action. Example: CREATE TRIGGER trigger_name INSTEAD OF INSERT ON table_name FOR EACH ROW BEGIN ... END;',
    insertText: 'INSTEAD',
    detail: 'INSTEAD',
  },
  {
    label: 'INT',
    documentation:
      'Defines an integer data type. Example: CREATE TABLE table_name (column_name INT);',
    insertText: 'INT',
    detail: 'INT',
  },
  {
    label: 'INTEGER',
    documentation:
      'Defines an integer data type. Example: CREATE TABLE table_name (column_name INTEGER);',
    insertText: 'INTEGER',
    detail: 'INTEGER',
  },
  {
    label: 'INTERSECT',
    documentation:
      'Returns the intersection of two result sets. Example: SELECT * FROM table1 INTERSECT SELECT * FROM table2;',
    insertText: 'INTERSECT',
    detail: 'INTERSECT',
  },
  {
    label: 'INTERVAL',
    documentation:
      "Defines a time interval. Example: SELECT CURRENT_TIMESTAMP + INTERVAL '1' DAY;",
    insertText: 'INTERVAL',
    detail: 'INTERVAL',
  },
  {
    label: 'INTO',
    documentation:
      'Specifies the target table for an INSERT or SELECT INTO statement. Example: SELECT * INTO new_table FROM existing_table;',
    insertText: 'INTO',
    detail: 'INTO',
  },
  {
    label: 'IS',
    documentation:
      'Tests for a specific condition. Example: SELECT * FROM table_name WHERE column_name IS NULL;',
    insertText: 'IS',
    detail: 'IS',
  },
  {
    label: 'ISNULL',
    documentation:
      "Tests whether an expression is NULL. Example: SELECT ISNULL(column_name, 'default') FROM table_name;",
    insertText: 'ISNULL',
    detail: 'ISNULL',
  },
  {
    label: 'ISOLATION',
    documentation:
      'Specifies the isolation level for a transaction. Example: SET TRANSACTION ISOLATION LEVEL SERIALIZABLE;',
    insertText: 'ISOLATION',
    detail: 'ISOLATION',
  },
  {
    label: 'JOIN',
    documentation:
      'Combines rows from two or more tables based on a related column. Example: SELECT * FROM table1 JOIN table2 ON table1.column_name = table2.column_name;',
    insertText: 'JOIN',
    detail: 'JOIN',
  },
  {
    label: 'KEY',
    documentation:
      'Defines a key constraint. Example: CREATE TABLE table_name (column_name INT PRIMARY KEY);',
    insertText: 'KEY',
    detail: 'KEY',
  },
  {
    label: 'KILL',
    documentation: 'Terminates a session or query. Example: KILL session_id;',
    insertText: 'KILL',
    detail: 'KILL',
  },
  {
    label: 'LANGUAGE',
    documentation:
      'Specifies the language for a procedure or function. Example: CREATE FUNCTION function_name() RETURNS return_type LANGUAGE plpgsql AS $$ BEGIN ... END $$;',
    insertText: 'LANGUAGE',
    detail: 'LANGUAGE',
  },
  {
    label: 'LAST',
    documentation:
      'Returns the last value in a set of values. Example: SELECT LAST(column_name) FROM table_name;',
    insertText: 'LAST',
    detail: 'LAST',
  },
  {
    label: 'LEADING',
    documentation:
      "Used with the TRIM function to remove characters from the beginning of a string. Example: SELECT TRIM(LEADING ' ' FROM column_name) FROM table_name;",
    insertText: 'LEADING',
    detail: 'LEADING',
  },
  {
    label: 'LEFT',
    documentation:
      'Specifies a left outer join between two tables. Example: SELECT * FROM table1 LEFT JOIN table2 ON table1.column_name = table2.column_name;',
    insertText: 'LEFT',
    detail: 'LEFT',
  },
  {
    label: 'LEVEL',
    documentation:
      'Specifies the level in a hierarchical query. Example: SELECT LEVEL, column_name FROM table_name CONNECT BY PRIOR column_name = parent_column;',
    insertText: 'LEVEL',
    detail: 'LEVEL',
  },
  {
    label: 'LIKE',
    documentation:
      "Performs pattern matching using SQL's LIKE operator. Example: SELECT * FROM table_name WHERE column_name LIKE 'pattern';",
    insertText: 'LIKE',
    detail: 'LIKE',
  },
  {
    label: 'LIMIT',
    documentation:
      'Specifies the maximum number of rows to return in a result set. Example: SELECT * FROM table_name LIMIT 10;',
    insertText: 'LIMIT',
    detail: 'LIMIT',
  },
  {
    label: 'LINENO',
    documentation:
      'Sets the line number for an error message. Example: LINENO 100;',
    insertText: 'LINENO',
    detail: 'LINENO',
  },
  {
    label: 'LOAD',
    documentation:
      "Loads data into a table. Example: LOAD DATA INFILE 'file_path' INTO TABLE table_name;",
    insertText: 'LOAD',
    detail: 'LOAD',
  },
  {
    label: 'LOCAL',
    documentation:
      'Refers to local variables or temporary tables. Example: DECLARE LOCAL TEMPORARY TABLE table_name (column_name data_type);',
    insertText: 'LOCAL',
    detail: 'LOCAL',
  },
  {
    label: 'LOWER',
    documentation:
      'Converts a string to lowercase. Example: SELECT LOWER(column_name) FROM table_name;',
    insertText: 'LOWER',
    detail: 'LOWER',
  },
  {
    label: 'MATCH',
    documentation:
      'Specifies the match type for a foreign key constraint. Example: CREATE TABLE table_name (column_name INT, FOREIGN KEY (column_name) REFERENCES another_table (column_name) MATCH FULL);',
    insertText: 'MATCH',
    detail: 'MATCH',
  },
  {
    label: 'MATERIALIZED',
    documentation:
      'Creates a materialized view. Example: CREATE MATERIALIZED VIEW view_name AS SELECT * FROM table_name;',
    insertText: 'MATERIALIZED',
    detail: 'MATERIALIZED',
  },
  {
    label: 'MAX',
    documentation:
      'Returns the maximum value in a set of values. Example: SELECT MAX(column_name) FROM table_name;',
    insertText: 'MAX',
    detail: 'MAX(expression)',
  },
  {
    label: 'MERGE',
    documentation:
      'Merges rows from a source table into a target table. Example: MERGE INTO target_table USING source_table ON target_table.column_name = source_table.column_name WHEN MATCHED THEN UPDATE SET column_name = value WHEN NOT MATCHED THEN INSERT (column_name) VALUES (value);',
    insertText: 'MERGE',
    detail: 'MERGE',
  },
  {
    label: 'MIN',
    documentation:
      'Returns the minimum value in a set of values. Example: SELECT MIN(column_name) FROM table_name;',
    insertText: 'MIN',
    detail: 'MIN(expression)',
  },
  {
    label: 'MINUTE',
    documentation:
      'Extracts the minute part of a time or timestamp. Example: SELECT MINUTE(time_column) FROM table_name;',
    insertText: 'MINUTE',
    detail: 'MINUTE',
  },
  {
    label: 'MODULE',
    documentation:
      'Refers to a module of code or a library. Example: CREATE MODULE module_name AS ...;',
    insertText: 'MODULE',
    detail: 'MODULE',
  },
  {
    label: 'MONTH',
    documentation:
      'Extracts the month part of a date. Example: SELECT MONTH(date_column) FROM table_name;',
    insertText: 'MONTH',
    detail: 'MONTH',
  },
  {
    label: 'NAMES',
    documentation:
      "Specifies the character set for the database. Example: SET NAMES 'utf8';",
    insertText: 'NAMES',
    detail: 'NAMES',
  },
  {
    label: 'NATIONAL',
    documentation:
      'Defines a national character set. Example: CREATE TABLE table_name (column_name NATIONAL CHAR(10));',
    insertText: 'NATIONAL',
    detail: 'NATIONAL',
  },
  {
    label: 'NATURAL',
    documentation:
      'Specifies a natural join between two tables. Example: SELECT * FROM table1 NATURAL JOIN table2;',
    insertText: 'NATURAL',
    detail: 'NATURAL',
  },
  {
    label: 'NCHAR',
    documentation:
      'Defines a national character set string. Example: CREATE TABLE table_name (column_name NCHAR(10));',
    insertText: 'NCHAR',
    detail: 'NCHAR',
  },
  {
    label: 'NEXT',
    documentation:
      'Advances the cursor to the next row. Example: FETCH NEXT FROM cursor_name;',
    insertText: 'NEXT',
    detail: 'NEXT',
  },
  {
    label: 'NO',
    documentation:
      'Specifies a negative condition or disables a feature. Example: SET NO COUNT;',
    insertText: 'NO',
    detail: 'NO',
  },
  {
    label: 'NOCHECK',
    documentation:
      'Disables a constraint. Example: ALTER TABLE table_name NOCHECK CONSTRAINT constraint_name;',
    insertText: 'NOCHECK',
    detail: 'NOCHECK',
  },
  {
    label: 'NONCLUSTERED',
    documentation:
      'Defines a nonclustered index. Example: CREATE NONCLUSTERED INDEX index_name ON table_name (column_name);',
    insertText: 'NONCLUSTERED',
    detail: 'NONCLUSTERED',
  },
  {
    label: 'NONE',
    documentation:
      'Specifies no value or disables a feature. Example: SET XACT_ABORT NONE;',
    insertText: 'NONE',
    detail: 'NONE',
  },
  {
    label: 'NOT',
    documentation:
      'Negates a condition. Example: SELECT * FROM table_name WHERE column_name IS NOT NULL;',
    insertText: 'NOT',
    detail: 'NOT',
  },
  {
    label: 'NOTHING',
    documentation: 'Specifies no action or result. Example: RETURN NOTHING;',
    insertText: 'NOTHING',
    detail: 'NOTHING',
  },
  {
    label: 'NOTNULL',
    documentation:
      'Specifies that a column cannot contain NULL values. Example: CREATE TABLE table_name (column_name INT NOT NULL);',
    insertText: 'NOTNULL',
    detail: 'NOTNULL',
  },
  {
    label: 'NULL',
    documentation:
      'Represents a missing or unknown value. Example: SELECT * FROM table_name WHERE column_name IS NULL;',
    insertText: 'NULL',
    detail: 'NULL',
  },
  {
    label: 'NULLIF',
    documentation:
      'Returns NULL if two expressions are equal. Example: SELECT NULLIF(column1, column2) FROM table_name;',
    insertText: 'NULLIF',
    detail: 'NULLIF(expression1, expression2)',
  },
  {
    label: 'NULLS',
    documentation:
      'Specifies the handling of NULL values in sorting. Example: SELECT * FROM table_name ORDER BY column_name NULLS FIRST;',
    insertText: 'NULLS',
    detail: 'NULLS',
  },
  {
    label: 'NUMERIC',
    documentation:
      'Defines a numeric data type. Example: CREATE TABLE table_name (column_name NUMERIC(10, 2));',
    insertText: 'NUMERIC',
    detail: 'NUMERIC(precision, scale)',
  },
  {
    label: 'OCTET_LENGTH',
    documentation:
      'Returns the length of a string in bytes. Example: SELECT OCTET_LENGTH(column_name) FROM table_name;',
    insertText: 'OCTET_LENGTH',
    detail: 'OCTET_LENGTH(expression)',
  },
  {
    label: 'OF',
    documentation:
      'Specifies the ownership of an object. Example: GRANT SELECT ON OBJECT::table_name TO user_name;',
    insertText: 'OF',
    detail: 'OF',
  },
  {
    label: 'OFF',
    documentation: 'Disables a feature or option. Example: SET NOCOUNT OFF;',
    insertText: 'OFF',
    detail: 'OFF',
  },
  {
    label: 'OFFSET',
    documentation:
      'Specifies the number of rows to skip before starting to return rows. Example: SELECT * FROM table_name OFFSET 10 ROWS;',
    insertText: 'OFFSET',
    detail: 'OFFSET',
  },
  {
    label: 'OFFSETS',
    documentation:
      'Specifies the starting positions for a series of rows. Example: SELECT * FROM table_name ORDER BY column_name OFFSET 10 ROWS FETCH NEXT 10 ROWS ONLY;',
    insertText: 'OFFSETS',
    detail: 'OFFSETS',
  },
  {
    label: 'ON',
    documentation:
      'Specifies a condition for a join or enables a feature. Example: SELECT * FROM table1 JOIN table2 ON table1.column_name = table2.column_name;',
    insertText: 'ON',
    detail: 'ON',
  },
  {
    label: 'ONLY',
    documentation:
      'Selects only rows that match a specific condition. Example: SELECT * FROM ONLY table_name;',
    insertText: 'ONLY',
    detail: 'ONLY',
  },
  {
    label: 'OPEN',
    documentation:
      'Opens a cursor for fetching rows. Example: OPEN cursor_name;',
    insertText: 'OPEN',
    detail: 'OPEN',
  },
  {
    label: 'OPENDATASOURCE',
    documentation:
      "Provides ad hoc connection information as part of a four-part object name without using a linked server name. Example: SELECT * FROM OPENDATASOURCE('provider_name', 'datasource')...table_name;",
    insertText: 'OPENDATASOURCE',
    detail: 'OPENDATASOURCE',
  },
  {
    label: 'OPENQUERY',
    documentation:
      "Executes a pass-through query on a linked server. Example: SELECT * FROM OPENQUERY(linked_server, 'query');",
    insertText: 'OPENQUERY',
    detail: 'OPENQUERY',
  },
  {
    label: 'OPENROWSET',
    documentation:
      "Provides ad hoc access to remote data using OLE DB. Example: SELECT * FROM OPENROWSET('provider_name', 'datasource', 'query');",
    insertText: 'OPENROWSET',
    detail: 'OPENROWSET',
  },
  {
    label: 'OPENXML',
    documentation:
      "Provides a rowset view over an XML document. Example: SELECT * FROM OPENXML(@xmlhandle, 'root/element') WITH (column_name datatype);",
    insertText: 'OPENXML',
    detail: 'OPENXML',
  },
  {
    label: 'OPTION',
    documentation:
      'Specifies query options. Example: SELECT * FROM table_name OPTION (RECOMPILE);',
    insertText: 'OPTION',
    detail: 'OPTION',
  },
  {
    label: 'OR',
    documentation:
      'Combines multiple conditions in a WHERE clause. Example: SELECT * FROM table_name WHERE column1 = value1 OR column2 = value2;',
    insertText: 'OR',
    detail: 'OR',
  },
  {
    label: 'ORDER',
    documentation:
      'Specifies the sort order of the result set. Example: SELECT * FROM table_name ORDER BY column_name ASC;',
    insertText: 'ORDER',
    detail: 'ORDER',
  },
  {
    label: 'OTHERS',
    documentation:
      'Specifies a condition for other users or roles. Example: GRANT SELECT ON table_name TO OTHERS;',
    insertText: 'OTHERS',
    detail: 'OTHERS',
  },
  {
    label: 'OUTER',
    documentation:
      'Specifies an outer join between two tables. Example: SELECT * FROM table1 LEFT OUTER JOIN table2 ON table1.column_name = table2.column_name;',
    insertText: 'OUTER',
    detail: 'OUTER',
  },
  {
    label: 'OUTPUT',
    documentation:
      'Specifies an output parameter for a procedure or function. Example: CREATE PROCEDURE procedure_name (OUTPUT parameter_name data_type) AS ...;',
    insertText: 'OUTPUT',
    detail: 'OUTPUT',
  },
  {
    label: 'OVER',
    documentation:
      'Specifies a window for window functions. Example: SELECT column_name, SUM(column_name) OVER (PARTITION BY column_name ORDER BY column_name) FROM table_name;',
    insertText: 'OVER',
    detail: 'OVER',
  },
  {
    label: 'OVERLAPS',
    documentation:
      'Checks if two date or time periods overlap. Example: SELECT * FROM table_name WHERE (start_date, end_date) OVERLAPS (start_date2, end_date2);',
    insertText: 'OVERLAPS',
    detail: 'OVERLAPS',
  },
  {
    label: 'PAD',
    documentation:
      "Specifies the padding character for a string. Example: SELECT LPAD(column_name, 10, ' ') FROM table_name;",
    insertText: 'PAD',
    detail: 'PAD',
  },
  {
    label: 'PARTIAL',
    documentation:
      'Specifies a partial index. Example: CREATE INDEX index_name ON table_name (column_name) WHERE condition;',
    insertText: 'PARTIAL',
    detail: 'PARTIAL',
  },
  {
    label: 'PARTITION',
    documentation:
      'Specifies the partitioning scheme for a table or index. Example: CREATE TABLE table_name (column_name data_type) PARTITION BY RANGE (column_name);',
    insertText: 'PARTITION',
    detail: 'PARTITION',
  },
  {
    label: 'PASCAL',
    documentation:
      'Refers to the Pascal programming language, often used in database systems for writing stored procedures or functions. Example: CREATE FUNCTION pascal_function() RETURNS void AS $$ PASCAL code $$ LANGUAGE pascal;',
    insertText: 'PASCAL',
    detail: 'PASCAL',
  },
  {
    label: 'PERCENT',
    documentation:
      'Specifies a percentage value. Example: SELECT TOP 10 PERCENT * FROM table_name;',
    insertText: 'PERCENT',
    detail: 'PERCENT',
  },
  {
    label: 'PIVOT',
    documentation:
      'Rotates a table-valued expression by turning the unique values from one column into multiple columns in the output. Example: SELECT * FROM (SELECT column_name, value FROM table_name) PIVOT (SUM(value) FOR column_name IN (value1, value2));',
    insertText: 'PIVOT',
    detail: 'PIVOT',
  },
  {
    label: 'PLAN',
    documentation:
      "Specifies an execution plan for a query. Example: SELECT * FROM table_name WITH (PLAN = 'query_plan');",
    insertText: 'PLAN',
    detail: 'PLAN',
  },
  {
    label: 'POSITION',
    documentation:
      "Returns the position of a substring in a string. Example: SELECT POSITION('substring' IN column_name) FROM table_name;",
    insertText: 'POSITION',
    detail: 'POSITION(substring IN string)',
  },
  {
    label: 'PRAGMA',
    documentation:
      'Executes a database command. Example: PRAGMA foreign_keys = ON;',
    insertText: 'PRAGMA',
    detail: 'PRAGMA',
  },
  {
    label: 'PRECEDING',
    documentation:
      'Specifies the number of rows to precede the current row in a window function. Example: SELECT SUM(column_name) OVER (ROWS 1 PRECEDING) FROM table_name;',
    insertText: 'PRECEDING',
    detail: 'PRECEDING',
  },
  {
    label: 'PRECISION',
    documentation:
      'Specifies the precision for a numeric column. Example: CREATE TABLE table_name (column_name DECIMAL(10, 2));',
    insertText: 'PRECISION',
    detail: 'PRECISION',
  },
  {
    label: 'PREPARE',
    documentation:
      'Prepares a SQL statement for execution. Example: PREPARE stmt_name AS SELECT * FROM table_name;',
    insertText: 'PREPARE',
    detail: 'PREPARE',
  },
  {
    label: 'PRESERVE',
    documentation:
      'Specifies that certain settings should be preserved. Example: SET PRESERVE ROWS;',
    insertText: 'PRESERVE',
    detail: 'PRESERVE',
  },
  {
    label: 'PRIMARY',
    documentation:
      'Defines a primary key constraint. Example: CREATE TABLE table_name (column_name INT PRIMARY KEY);',
    insertText: 'PRIMARY',
    detail: 'PRIMARY',
  },
  {
    label: 'PRINT',
    documentation: "Prints a message. Example: PRINT 'Hello, world!';",
    insertText: 'PRINT',
    detail: 'PRINT',
  },
  {
    label: 'PRIOR',
    documentation:
      'Specifies the previous row in a hierarchical query. Example: SELECT column_name FROM table_name CONNECT BY PRIOR column_name = parent_column;',
    insertText: 'PRIOR',
    detail: 'PRIOR',
  },
  {
    label: 'PRIVILEGES',
    documentation:
      'Specifies the privileges for a user or role. Example: GRANT ALL PRIVILEGES ON table_name TO user_name;',
    insertText: 'PRIVILEGES',
    detail: 'PRIVILEGES',
  },
  {
    label: 'PROC',
    documentation:
      'Creates or refers to a stored procedure. Example: CREATE PROC procedure_name AS BEGIN ... END;',
    insertText: 'PROC',
    detail: 'PROC',
  },
  {
    label: 'PROCEDURE',
    documentation:
      'Creates or refers to a stored procedure. Example: CREATE PROCEDURE procedure_name AS BEGIN ... END;',
    insertText: 'PROCEDURE',
    detail: 'PROCEDURE',
  },
  {
    label: 'PUBLIC',
    documentation:
      'Specifies the public role or schema. Example: GRANT SELECT ON table_name TO PUBLIC;',
    insertText: 'PUBLIC',
    detail: 'PUBLIC',
  },
  {
    label: 'QUERY',
    documentation:
      "Executes a SQL query. Example: EXECUTE QUERY 'SELECT * FROM table_name';",
    insertText: 'QUERY',
    detail: 'QUERY',
  },
  {
    label: 'RAISE',
    documentation:
      "Raises an exception or message. Example: RAISE EXCEPTION 'Error message';",
    insertText: 'RAISE',
    detail: 'RAISE',
  },
  {
    label: 'RAISERROR',
    documentation:
      "Generates an error message and initiates error processing for the session. Example: RAISERROR('Error message', 16, 1);",
    insertText: 'RAISERROR',
    detail: 'RAISERROR',
  },
  {
    label: 'RANGE',
    documentation:
      'Specifies the range of rows in a window function. Example: SELECT SUM(column_name) OVER (RANGE BETWEEN UNBOUNDED PRECEDING AND CURRENT ROW) FROM table_name;',
    insertText: 'RANGE',
    detail: 'RANGE',
  },
  {
    label: 'READ',
    documentation:
      'Specifies the read operation or isolation level. Example: SET TRANSACTION ISOLATION LEVEL READ COMMITTED;',
    insertText: 'READ',
    detail: 'READ',
  },
  {
    label: 'READTEXT',
    documentation:
      'Reads text, ntext, or image values from a table. Example: READTEXT table_name.column_name @text_ptr 0 100;',
    insertText: 'READTEXT',
    detail: 'READTEXT',
  },
  {
    label: 'REAL',
    documentation:
      'Defines a real number data type. Example: CREATE TABLE table_name (column_name REAL);',
    insertText: 'REAL',
    detail: 'REAL',
  },
  {
    label: 'RECONFIGURE',
    documentation:
      "Updates the currently configured value of a configuration option. Example: EXEC SP_CONFIGURE 'show advanced options', 1; RECONFIGURE;",
    insertText: 'RECONFIGURE',
    detail: 'RECONFIGURE',
  },
  {
    label: 'RECURSIVE',
    documentation:
      'Specifies a recursive common table expression. Example: WITH RECURSIVE cte_name AS (SELECT ... UNION ALL SELECT ...) SELECT * FROM cte_name;',
    insertText: 'RECURSIVE',
    detail: 'RECURSIVE',
  },
  {
    label: 'REFERENCES',
    documentation:
      'Defines a foreign key constraint. Example: CREATE TABLE table_name (column_name INT, FOREIGN KEY (column_name) REFERENCES another_table (column_name));',
    insertText: 'REFERENCES',
    detail: 'REFERENCES',
  },
  {
    label: 'REGEXP',
    documentation:
      "Performs a regular expression match. Example: SELECT * FROM table_name WHERE column_name REGEXP 'pattern';",
    insertText: 'REGEXP',
    detail: 'REGEXP',
  },
  {
    label: 'REINDEX',
    documentation:
      'Rebuilds indexes on a table. Example: REINDEX TABLE table_name;',
    insertText: 'REINDEX',
    detail: 'REINDEX',
  },
  {
    label: 'RELATIVE',
    documentation:
      'Moves the cursor a relative number of rows. Example: FETCH RELATIVE 5 FROM cursor_name;',
    insertText: 'RELATIVE',
    detail: 'RELATIVE',
  },
  {
    label: 'RELEASE',
    documentation:
      'Releases a savepoint in a transaction. Example: RELEASE SAVEPOINT savepoint_name;',
    insertText: 'RELEASE',
    detail: 'RELEASE',
  },
  {
    label: 'RENAME',
    documentation:
      'Renames a database object. Example: ALTER TABLE table_name RENAME TO new_table_name;',
    insertText: 'RENAME',
    detail: 'RENAME',
  },
  {
    label: 'REPLACE',
    documentation:
      "Replaces a string in a column with another string. Example: SELECT REPLACE(column_name, 'old_string', 'new_string') FROM table_name;",
    insertText: 'REPLACE',
    detail: 'REPLACE(expression, search, replace)',
  },
  {
    label: 'REPLICATION',
    documentation:
      'Refers to database replication operations. Example: CREATE PUBLICATION publication_name FOR TABLE table_name;',
    insertText: 'REPLICATION',
    detail: 'REPLICATION',
  },
  {
    label: 'RESTORE',
    documentation:
      "Restores a database from a backup. Example: RESTORE DATABASE database_name FROM DISK = 'path_to_backup';",
    insertText: 'RESTORE',
    detail: 'RESTORE',
  },
  {
    label: 'RESTRICT',
    documentation:
      'Specifies that an action cannot be performed if there are dependent objects. Example: DROP TABLE table_name RESTRICT;',
    insertText: 'RESTRICT',
    detail: 'RESTRICT',
  },
  {
    label: 'RETURN',
    documentation:
      'Exits a function and returns a value. Example: CREATE FUNCTION function_name() RETURNS return_type AS $$ BEGIN RETURN value; END $$ LANGUAGE plpgsql;',
    insertText: 'RETURN',
    detail: 'RETURN',
  },
  {
    label: 'RETURNING',
    documentation:
      'Returns values from inserted, updated, or deleted rows. Example: INSERT INTO table_name (column_name) VALUES (value) RETURNING column_name;',
    insertText: 'RETURNING',
    detail: 'RETURNING',
  },
  {
    label: 'REVERT',
    documentation: 'Reverts to a previous execution context. Example: REVERT;',
    insertText: 'REVERT',
    detail: 'REVERT',
  },
  {
    label: 'REVOKE',
    documentation:
      'Revokes privileges on database objects. Example: REVOKE SELECT ON table_name FROM user_name;',
    insertText: 'REVOKE',
    detail: 'REVOKE',
  },
  {
    label: 'RIGHT',
    documentation:
      'Specifies a right outer join between two tables. Example: SELECT * FROM table1 RIGHT JOIN table2 ON table1.column_name = table2.column_name;',
    insertText: 'RIGHT',
    detail: 'RIGHT',
  },
  {
    label: 'ROLLBACK',
    documentation: 'Rolls back a transaction. Example: ROLLBACK TRANSACTION;',
    insertText: 'ROLLBACK',
    detail: 'ROLLBACK',
  },
  {
    label: 'ROW',
    documentation:
      'Refers to a single row of a table. Example: SELECT ROW(column1, column2) FROM table_name;',
    insertText: 'ROW',
    detail: 'ROW',
  },
  {
    label: 'ROWCOUNT',
    documentation:
      'Returns the number of rows affected by the last statement. Example: SELECT @@ROWCOUNT;',
    insertText: 'ROWCOUNT',
    detail: 'ROWCOUNT',
  },
  {
    label: 'ROWGUIDCOL',
    documentation:
      'Specifies a uniqueidentifier column. Example: CREATE TABLE table_name (column_name UNIQUEIDENTIFIER ROWGUIDCOL);',
    insertText: 'ROWGUIDCOL',
    detail: 'ROWGUIDCOL',
  },
  {
    label: 'ROWS',
    documentation:
      'Specifies the number of rows for a window function. Example: SELECT SUM(column_name) OVER (ROWS BETWEEN 1 PRECEDING AND 1 FOLLOWING) FROM table_name;',
    insertText: 'ROWS',
    detail: 'ROWS',
  },
  {
    label: 'RULE',
    documentation:
      'Defines a rule for a table or view. Example: CREATE RULE rule_name AS ON INSERT TO table_name DO INSTEAD NOTHING;',
    insertText: 'RULE',
    detail: 'RULE',
  },
  {
    label: 'SAVE',
    documentation:
      'Saves the state of a transaction. Example: SAVE TRANSACTION savepoint_name;',
    insertText: 'SAVE',
    detail: 'SAVE',
  },
  {
    label: 'SAVEPOINT',
    documentation:
      'Sets a savepoint in a transaction. Example: SAVEPOINT savepoint_name;',
    insertText: 'SAVEPOINT',
    detail: 'SAVEPOINT',
  },
  {
    label: 'SCHEMA',
    documentation:
      'Defines a database schema. Example: CREATE SCHEMA schema_name AUTHORIZATION user_name;',
    insertText: 'SCHEMA',
    detail: 'SCHEMA',
  },
  {
    label: 'SCROLL',
    documentation:
      'Defines a scrollable cursor. Example: DECLARE cursor_name SCROLL CURSOR FOR SELECT column_name FROM table_name;',
    insertText: 'SCROLL',
    detail: 'SCROLL',
  },
  {
    label: 'SECOND',
    documentation:
      'Extracts the second part of a time or timestamp. Example: SELECT SECOND(time_column) FROM table_name;',
    insertText: 'SECOND',
    detail: 'SECOND',
  },
  {
    label: 'SECTION',
    documentation:
      'Refers to a section of a SQL statement. Example: EXEC SQL BEGIN DECLARE SECTION; ... EXEC SQL END DECLARE SECTION;',
    insertText: 'SECTION',
    detail: 'SECTION',
  },
  {
    label: 'SECURITYAUDIT',
    documentation:
      "Specifies security audit operations. Example: CREATE SERVER AUDIT audit_name TO FILE (FILEPATH = 'path');",
    insertText: 'SECURITYAUDIT',
    detail: 'SECURITYAUDIT',
  },
  {
    label: 'SELECT',
    documentation:
      'Retrieves data from a database. Example: SELECT column_name FROM table_name;',
    insertText: 'SELECT',
    detail: 'SELECT',
  },
  {
    label: 'SEMANTICKEYPHRASETABLE',
    documentation:
      'Returns a table of key phrases found in the specified column. Example: SELECT * FROM SEMANTICKEYPHRASETABLE(table_name, column_name);',
    insertText: 'SEMANTICKEYPHRASETABLE',
    detail: 'SEMANTICKEYPHRASETABLE',
  },
  {
    label: 'SEMANTICSIMILARITYDETAILSTABLE',
    documentation:
      'Returns a table of similarity details for the specified column. Example: SELECT * FROM SEMANTICSIMILARITYDETAILSTABLE(table_name, column_name);',
    insertText: 'SEMANTICSIMILARITYDETAILSTABLE',
    detail: 'SEMANTICSIMILARITYDETAILSTABLE',
  },
  {
    label: 'SEMANTICSIMILARITYTABLE',
    documentation:
      'Returns a table of similarity results for the specified column. Example: SELECT * FROM SEMANTICSIMILARITYTABLE(table_name, column_name);',
    insertText: 'SEMANTICSIMILARITYTABLE',
    detail: 'SEMANTICSIMILARITYTABLE',
  },
  {
    label: 'SESSION',
    documentation:
      'Refers to the current database session. Example: SELECT SESSION_USER;',
    insertText: 'SESSION',
    detail: 'SESSION',
  },
  {
    label: 'SESSION_USER',
    documentation:
      'Returns the name of the current user. Example: SELECT SESSION_USER;',
    insertText: 'SESSION_USER',
    detail: 'SESSION_USER',
  },
  {
    label: 'SET',
    documentation:
      'Assigns a value to a variable or sets a configuration option. Example: SET @variable_name = value;',
    insertText: 'SET',
    detail: 'SET',
  },
  {
    label: 'SETUSER',
    documentation:
      "Changes the current user context. Example: SETUSER 'user_name';",
    insertText: 'SETUSER',
    detail: 'SETUSER',
  },
  {
    label: 'SHUTDOWN',
    documentation: 'Shuts down the database server. Example: SHUTDOWN;',
    insertText: 'SHUTDOWN',
    detail: 'SHUTDOWN',
  },
  {
    label: 'SIZE',
    documentation:
      'Specifies the size of a database object. Example: CREATE TABLE table_name (column_name VARCHAR(SIZE));',
    insertText: 'SIZE',
    detail: 'SIZE',
  },
  {
    label: 'SMALLINT',
    documentation:
      'Defines a small integer data type. Example: CREATE TABLE table_name (column_name SMALLINT);',
    insertText: 'SMALLINT',
    detail: 'SMALLINT',
  },
  {
    label: 'SOME',
    documentation:
      'Compares a value to some values in a list or subquery. Example: SELECT * FROM table_name WHERE column_name = SOME (SELECT column_name FROM another_table);',
    insertText: 'SOME',
    detail: 'SOME',
  },
  {
    label: 'SPACE',
    documentation:
      'Returns a string of repeated spaces. Example: SELECT SPACE(10);',
    insertText: 'SPACE',
    detail: 'SPACE(count)',
  },
  {
    label: 'SQL',
    documentation:
      'Refers to SQL operations or commands. Example: EXEC SQL SELECT * FROM table_name;',
    insertText: 'SQL',
    detail: 'SQL',
  },
  {
    label: 'SQLCA',
    documentation:
      'Refers to the SQL Communications Area. Example: EXEC SQL INCLUDE SQLCA;',
    insertText: 'SQLCA',
    detail: 'SQLCA',
  },
  {
    label: 'SQLCODE',
    documentation:
      'Returns the SQL return code of the last executed statement. Example: IF SQLCODE < 0 THEN ...;',
    insertText: 'SQLCODE',
    detail: 'SQLCODE',
  },
  {
    label: 'SQLERROR',
    documentation:
      'Handles SQL errors in embedded SQL. Example: WHENEVER SQLERROR CONTINUE;',
    insertText: 'SQLERROR',
    detail: 'SQLERROR',
  },
  {
    label: 'SQLSTATE',
    documentation:
      "Returns the SQLSTATE code of the last executed statement. Example: IF SQLSTATE = '00000' THEN ...;",
    insertText: 'SQLSTATE',
    detail: 'SQLSTATE',
  },
  {
    label: 'SQLWARNING',
    documentation:
      'Handles SQL warnings in embedded SQL. Example: WHENEVER SQLWARNING CONTINUE;',
    insertText: 'SQLWARNING',
    detail: 'SQLWARNING',
  },
  {
    label: 'STATISTICS',
    documentation:
      'Collects statistics about the contents of tables. Example: ANALYZE TABLE table_name COMPUTE STATISTICS;',
    insertText: 'STATISTICS',
    detail: 'STATISTICS',
  },
  {
    label: 'SUBSTRING',
    documentation:
      'Returns a substring of a string. Example: SELECT SUBSTRING(column_name, 1, 10) FROM table_name;',
    insertText: 'SUBSTRING',
    detail: 'SUBSTRING(string, start, length)',
  },
  {
    label: 'SUM',
    documentation:
      'Returns the sum of a numeric column. Example: SELECT SUM(column_name) FROM table_name;',
    insertText: 'SUM',
    detail: 'SUM(expression)',
  },
  {
    label: 'SYSTEM_USER',
    documentation:
      'Returns the name of the current user. Example: SELECT SYSTEM_USER;',
    insertText: 'SYSTEM_USER',
    detail: 'SYSTEM_USER',
  },
  {
    label: 'TABLE',
    documentation:
      'Creates or refers to a table. Example: CREATE TABLE table_name (column_name data_type);',
    insertText: 'TABLE',
    detail: 'TABLE',
  },
  {
    label: 'TABLESAMPLE',
    documentation:
      'Retrieves a random sample of data from a table. Example: SELECT * FROM table_name TABLESAMPLE SYSTEM (10 PERCENT);',
    insertText: 'TABLESAMPLE',
    detail: 'TABLESAMPLE',
  },
  {
    label: 'TEMP',
    documentation:
      'Creates a temporary table. Example: CREATE TEMP TABLE table_name (column_name data_type);',
    insertText: 'TEMP',
    detail: 'TEMP',
  },
  {
    label: 'TEMPORARY',
    documentation:
      'Creates a temporary table. Example: CREATE TEMPORARY TABLE table_name (column_name data_type);',
    insertText: 'TEMPORARY',
    detail: 'TEMPORARY',
  },
  {
    label: 'TEXTSIZE',
    documentation:
      'Sets the maximum size of text or image data returned with a SELECT statement. Example: SET TEXTSIZE 1000;',
    insertText: 'TEXTSIZE',
    detail: 'TEXTSIZE',
  },
  {
    label: 'THEN',
    documentation:
      'Specifies the result of an IF or CASE statement when the condition is true. Example: IF condition THEN action END IF;',
    insertText: 'THEN',
    detail: 'THEN',
  },
  {
    label: 'TIES',
    documentation:
      'Specifies how to handle ties in a ranking function. Example: SELECT * FROM table_name ORDER BY column_name FETCH FIRST 10 ROWS WITH TIES;',
    insertText: 'TIES',
    detail: 'TIES',
  },
  {
    label: 'TIME',
    documentation:
      'Defines a time data type. Example: CREATE TABLE table_name (column_name TIME);',
    insertText: 'TIME',
    detail: 'TIME',
  },
  {
    label: 'TIMESTAMP',
    documentation:
      'Defines a timestamp data type. Example: CREATE TABLE table_name (column_name TIMESTAMP);',
    insertText: 'TIMESTAMP',
    detail: 'TIMESTAMP',
  },
  {
    label: 'TIMEZONE_HOUR',
    documentation:
      "Extracts the hour part of the time zone from a date or timestamp. Example: SELECT TIMEZONE_HOUR(TIMESTAMP '2023-07-05 00:00:00+02:00') FROM table_name;",
    insertText: 'TIMEZONE_HOUR',
    detail: 'TIMEZONE_HOUR',
  },
  {
    label: 'TIMEZONE_MINUTE',
    documentation:
      "Extracts the minute part of the time zone from a date or timestamp. Example: SELECT TIMEZONE_MINUTE(TIMESTAMP '2023-07-05 00:00:00+02:00') FROM table_name;",
    insertText: 'TIMEZONE_MINUTE',
    detail: 'TIMEZONE_MINUTE',
  },
  {
    label: 'TO',
    documentation:
      'Specifies the target of a GRANT or REVOKE statement. Example: GRANT SELECT ON table_name TO user_name;',
    insertText: 'TO',
    detail: 'TO',
  },
  {
    label: 'TOP',
    documentation:
      'Limits the number of rows returned in a result set. Example: SELECT TOP 10 * FROM table_name;',
    insertText: 'TOP',
    detail: 'TOP',
  },
  {
    label: 'TRAILING',
    documentation:
      "Used with the TRIM function to remove characters from the end of a string. Example: SELECT TRIM(TRAILING ' ' FROM column_name) FROM table_name;",
    insertText: 'TRAILING',
    detail: 'TRAILING',
  },
  {
    label: 'TRAN',
    documentation: 'Abbreviation for TRANSACTION. Example: BEGIN TRAN;',
    insertText: 'TRAN',
    detail: 'TRAN',
  },
  {
    label: 'TRANSACTION',
    documentation:
      'Begins, commits, or rolls back a transaction. Example: BEGIN TRANSACTION;',
    insertText: 'TRANSACTION',
    detail: 'TRANSACTION',
  },
  {
    label: 'TRANSLATE',
    documentation:
      'Replaces a sequence of characters in a string with another set of characters. Example: SELECT TRANSLATE(column_name USING charset) FROM table_name;',
    insertText: 'TRANSLATE',
    detail: 'TRANSLATE(string, from, to)',
  },
  {
    label: 'TRANSLATION',
    documentation:
      "Specifies the translation of a string. Example: CREATE TRANSLATION translation_name FOR 'string' FROM 'charset';",
    insertText: 'TRANSLATION',
    detail: 'TRANSLATION',
  },
  {
    label: 'TRIGGER',
    documentation:
      'Creates a trigger that performs an action in response to an event. Example: CREATE TRIGGER trigger_name AFTER INSERT ON table_name FOR EACH ROW BEGIN ... END;',
    insertText: 'TRIGGER',
    detail: 'TRIGGER',
  },
  {
    label: 'TRIM',
    documentation:
      'Removes leading and trailing spaces from a string. Example: SELECT TRIM(column_name) FROM table_name;',
    insertText: 'TRIM',
    detail: 'TRIM(string)',
  },
  {
    label: 'TRUE',
    documentation:
      'Represents a boolean true value. Example: SELECT * FROM table_name WHERE column_name = TRUE;',
    insertText: 'TRUE',
    detail: 'TRUE',
  },
  {
    label: 'TRUNCATE',
    documentation:
      'Removes all rows from a table without logging individual row deletions. Example: TRUNCATE TABLE table_name;',
    insertText: 'TRUNCATE',
    detail: 'TRUNCATE',
  },
  {
    label: 'TRY_CONVERT',
    documentation:
      'Attempts to convert a value to a specified data type. Example: SELECT TRY_CONVERT(INT, column_name) FROM table_name;',
    insertText: 'TRY_CONVERT',
    detail: 'TRY_CONVERT(data_type, expression)',
  },
  {
    label: 'TSEQUAL',
    documentation:
      'Compares two timestamp values. Example: SELECT * FROM table_name WHERE TSEQUAL(timestamp1, timestamp2);',
    insertText: 'TSEQUAL',
    detail: 'TSEQUAL',
  },
  {
    label: 'UNBOUNDED',
    documentation:
      'Specifies an unbounded range of rows in a window function. Example: SELECT SUM(column_name) OVER (ROWS UNBOUNDED PRECEDING) FROM table_name;',
    insertText: 'UNBOUNDED',
    detail: 'UNBOUNDED',
  },
  {
    label: 'UNION',
    documentation:
      'Combines the result sets of two or more SELECT statements. Example: SELECT column_name FROM table1 UNION SELECT column_name FROM table2;',
    insertText: 'UNION',
    detail: 'UNION',
  },
  {
    label: 'UNIQUE',
    documentation:
      'Ensures that all values in a column are unique. Example: CREATE TABLE table_name (column_name INT UNIQUE);',
    insertText: 'UNIQUE',
    detail: 'UNIQUE',
  },
  {
    label: 'UNKNOWN',
    documentation:
      'Represents an unknown value. Example: SELECT * FROM table_name WHERE column_name IS UNKNOWN;',
    insertText: 'UNKNOWN',
    detail: 'UNKNOWN',
  },
  {
    label: 'UNPIVOT',
    documentation:
      'Turns columns into rows. Example: SELECT * FROM (SELECT column_name, value FROM table_name) UNPIVOT (value FOR column_name IN (value1, value2));',
    insertText: 'UNPIVOT',
    detail: 'UNPIVOT',
  },
  {
    label: 'UPDATE',
    documentation:
      'Modifies existing rows in a table. Example: UPDATE table_name SET column_name = value WHERE condition;',
    insertText: 'UPDATE',
    detail: 'UPDATE',
  },
  {
    label: 'UPDATETEXT',
    documentation:
      "Updates text, ntext, or image values in a table. Example: UPDATETEXT table_name.column_name @text_ptr NULL NULL 'new_text';",
    insertText: 'UPDATETEXT',
    detail: 'UPDATETEXT',
  },
  {
    label: 'UPPER',
    documentation:
      'Converts a string to uppercase. Example: SELECT UPPER(column_name) FROM table_name;',
    insertText: 'UPPER',
    detail: 'UPPER',
  },
  {
    label: 'USAGE',
    documentation:
      'Grants usage privileges on a database object. Example: GRANT USAGE ON SCHEMA schema_name TO user_name;',
    insertText: 'USAGE',
    detail: 'USAGE',
  },
  {
    label: 'USE',
    documentation: 'Changes the database context. Example: USE database_name;',
    insertText: 'USE',
    detail: 'USE',
  },
  {
    label: 'USER',
    documentation:
      'Returns the name of the current user. Example: SELECT USER;',
    insertText: 'USER',
    detail: 'USER',
  },
  {
    label: 'USING',
    documentation:
      'Specifies the column to use in a join. Example: SELECT * FROM table1 JOIN table2 USING (column_name);',
    insertText: 'USING',
    detail: 'USING',
  },
  {
    label: 'VACUUM',
    documentation:
      'Reclaims storage and optimizes the database. Example: VACUUM;',
    insertText: 'VACUUM',
    detail: 'VACUUM',
  },
  {
    label: 'VALUE',
    documentation:
      'Specifies the value to insert or update. Example: INSERT INTO table_name (column_name) VALUES (value);',
    insertText: 'VALUE',
    detail: 'VALUE',
  },
  {
    label: 'VALUES',
    documentation:
      'Specifies the values to insert into a table. Example: INSERT INTO table_name (column_name) VALUES (value);',
    insertText: 'VALUES',
    detail: 'VALUES',
  },
  {
    label: 'VARCHAR',
    documentation:
      'Defines a variable-length character string. Example: CREATE TABLE table_name (column_name VARCHAR(255));',
    insertText: 'VARCHAR',
    detail: 'VARCHAR(length)',
  },
  {
    label: 'VARYING',
    documentation:
      'Defines a varying character string. Example: CREATE TABLE table_name (column_name CHARACTER VARYING(255));',
    insertText: 'VARYING',
    detail: 'VARYING',
  },
  {
    label: 'VIEW',
    documentation:
      'Creates or refers to a view. Example: CREATE VIEW view_name AS SELECT * FROM table_name;',
    insertText: 'VIEW',
    detail: 'VIEW',
  },
  {
    label: 'VIRTUAL',
    documentation:
      'Specifies a virtual column. Example: CREATE TABLE table_name (column_name INT, virtual_column INT GENERATED ALWAYS AS (column_name * 2) VIRTUAL);',
    insertText: 'VIRTUAL',
    detail: 'VIRTUAL',
  },
  {
    label: 'WAITFOR',
    documentation:
      "Pauses the execution of a batch, stored procedure, or transaction for a specified period of time. Example: WAITFOR DELAY '00:01:00';",
    insertText: 'WAITFOR',
    detail: 'WAITFOR',
  },
  {
    label: 'WHEN',
    documentation:
      'Specifies a condition in a CASE statement. Example: SELECT CASE WHEN condition THEN result ELSE default END FROM table_name;',
    insertText: 'WHEN',
    detail: 'WHEN',
  },
  {
    label: 'WHENEVER',
    documentation:
      'Specifies actions to take when an SQL condition occurs. Example: WHENEVER SQLERROR CONTINUE;',
    insertText: 'WHENEVER',
    detail: 'WHENEVER',
  },
  {
    label: 'WHERE',
    documentation:
      'Filters rows based on a condition. Example: SELECT * FROM table_name WHERE condition;',
    insertText: 'WHERE',
    detail: 'WHERE',
  },
  {
    label: 'WHILE',
    documentation:
      'Repeats a set of SQL statements while a condition is true. Example: WHILE condition BEGIN ... END;',
    insertText: 'WHILE',
    detail: 'WHILE',
  },
  {
    label: 'WINDOW',
    documentation:
      'Defines a window for window functions. Example: SELECT column_name, SUM(column_name) OVER (WINDOW w AS (PARTITION BY column_name ORDER BY column_name)) FROM table_name;',
    insertText: 'WINDOW',
    detail: 'WINDOW',
  },
  {
    label: 'WITH',
    documentation:
      'Specifies a common table expression (CTE) or recursive query. Example: WITH cte_name AS (SELECT column_name FROM table_name) SELECT * FROM cte_name;',
    insertText: 'WITH',
    detail: 'WITH',
  },
  {
    label: 'WITHIN GROUP',
    documentation:
      'Defines a group for ordered-set aggregate functions. Example: SELECT percentile_cont(0.5) WITHIN GROUP (ORDER BY column_name) FROM table_name;',
    insertText: 'WITHIN GROUP',
    detail: 'WITHIN GROUP',
  },
  {
    label: 'WITHOUT',
    documentation:
      'Specifies the absence of a feature or option. Example: CREATE TABLE table_name (column_name INT) WITHOUT ROWID;',
    insertText: 'WITHOUT',
    detail: 'WITHOUT',
  },
  {
    label: 'WORK',
    documentation: 'Specifies the work of a transaction. Example: COMMIT WORK;',
    insertText: 'WORK',
    detail: 'WORK',
  },
  {
    label: 'WRITE',
    documentation:
      "Writes to a file or table. Example: WRITE OUTFILE 'file_path' FROM table_name;",
    insertText: 'WRITE',
    detail: 'WRITE',
  },
  {
    label: 'WRITETEXT',
    documentation:
      "Writes text, ntext, or image values to a table. Example: WRITETEXT table_name.column_name @text_ptr 'new_text';",
    insertText: 'WRITETEXT',
    detail: 'WRITETEXT',
  },
  {
    label: 'YEAR',
    documentation:
      'Extracts the year part of a date. Example: SELECT YEAR(date_column) FROM table_name;',
    insertText: 'YEAR',
    detail: 'YEAR',
  },
  {
    label: 'ZONE',
    documentation:
      "Specifies the time zone. Example: SELECT TIMEZONE 'UTC' FROM table_name;",
    insertText: 'ZONE',
    detail: 'ZONE',
  },
];

// includes only ones that are not already in "keywords" list
export const monacoEditorTrinoSqlFunctions = [
  {
    label: 'acos',
    documentation:
      'Returns the arc cosine of a number. Example: SELECT acos(1);',
    insertText: 'acos',
    detail: 'acos(x) → double',
  },
  {
    label: 'all_match',
    documentation:
      'Returns whether all elements of an array match the given predicate. Example: SELECT all_match(array[1, 2, 3], x -> x > 0);',
    insertText: 'all_match',
    detail: 'all_match(array(T), function(T, boolean)) → boolean',
  },
  {
    label: 'any_match',
    documentation:
      'Returns whether any element of an array matches the given predicate. Example: SELECT any_match(array[1, 2, 3], x -> x > 2);',
    insertText: 'any_match',
    detail: 'any_match(array(T), function(T, boolean)) → boolean',
  },
  {
    label: 'any_value',
    documentation:
      'Returns an arbitrary non-null value from the input. Example: SELECT any_value(column) FROM table;',
    insertText: 'any_value',
    detail: 'any_value(x) → x',
  },
  {
    label: 'approx_distinct',
    documentation:
      'Returns an approximate number of distinct input values. Example: SELECT approx_distinct(column) FROM table;',
    insertText: 'approx_distinct',
    detail: 'approx_distinct(x) → bigint',
  },
  {
    label: 'approx_most_frequent',
    documentation:
      'Returns the most frequent values in the input with their frequencies. Example: SELECT approx_most_frequent(column) FROM table;',
    insertText: 'approx_most_frequent',
    detail: 'approx_most_frequent(x, k) → map<type, bigint>',
  },
  {
    label: 'approx_percentile',
    documentation:
      'Returns the approximate percentile for the input. Example: SELECT approx_percentile(column, 0.5) FROM table;',
    insertText: 'approx_percentile',
    detail: 'approx_percentile(x, percentile) → x',
  },
  {
    label: 'approx_set',
    documentation:
      'Returns a set for approximate count distinct operations. Example: SELECT approx_set(column) FROM table;',
    insertText: 'approx_set',
    detail: 'approx_set(x) → HyperLogLog',
  },
  {
    label: 'arbitrary',
    documentation:
      'Returns an arbitrary value from the input. Example: SELECT arbitrary(column) FROM table;',
    insertText: 'arbitrary',
    detail: 'arbitrary(x) → x',
  },
  {
    label: 'array_agg',
    documentation:
      'Aggregates all the values in the input into an array. Example: SELECT array_agg(column) FROM table;',
    insertText: 'array_agg',
    detail: 'array_agg(x) → array<x>',
  },
  {
    label: 'array_distinct',
    documentation:
      'Returns an array with distinct elements from the input array. Example: SELECT array_distinct(array[1, 2, 2, 3]);',
    insertText: 'array_distinct',
    detail: 'array_distinct(array<T>) → array<T>',
  },
  {
    label: 'array_except',
    documentation:
      'Returns an array with the elements of the first array that are not in the second array. Example: SELECT array_except(array[1, 2, 3], array[2]);',
    insertText: 'array_except',
    detail: 'array_except(array<T>, array<T>) → array<T>',
  },
  {
    label: 'array_intersect',
    documentation:
      'Returns an array with the elements that are common to both arrays. Example: SELECT array_intersect(array[1, 2, 3], array[2, 3, 4]);',
    insertText: 'array_intersect',
    detail: 'array_intersect(array<T>, array<T>) → array<T>',
  },
  {
    label: 'array_join',
    documentation:
      "Joins the elements of an array into a string, separated by the given delimiter. Example: SELECT array_join(array['a', 'b', 'c'], ', ');",
    insertText: 'array_join',
    detail: 'array_join(array<Varchar>, delimiter) → Varchar',
  },
  {
    label: 'array_max',
    documentation:
      'Returns the maximum value in an array. Example: SELECT array_max(array[1, 2, 3]);',
    insertText: 'array_max',
    detail: 'array_max(array<T>) → T',
  },
  {
    label: 'array_min',
    documentation:
      'Returns the minimum value in an array. Example: SELECT array_min(array[1, 2, 3]);',
    insertText: 'array_min',
    detail: 'array_min(array<T>) → T',
  },
  {
    label: 'array_position',
    documentation:
      'Returns the position of the first occurrence of an element in an array. Example: SELECT array_position(array[1, 2, 3], 2);',
    insertText: 'array_position',
    detail: 'array_position(array<T>, T) → bigint',
  },
  {
    label: 'array_remove',
    documentation:
      'Removes all occurrences of an element from an array. Example: SELECT array_remove(array[1, 2, 2, 3], 2);',
    insertText: 'array_remove',
    detail: 'array_remove(array<T>, T) → array<T>',
  },
  {
    label: 'array_sort',
    documentation:
      'Sorts the elements of an array. Example: SELECT array_sort(array[3, 1, 2]);',
    insertText: 'array_sort',
    detail: 'array_sort(array<T>) → array<T>',
  },
  {
    label: 'array_union',
    documentation:
      'Returns an array with the union of the elements of the two arrays. Example: SELECT array_union(array[1, 2], array[2, 3]);',
    insertText: 'array_union',
    detail: 'array_union(array<T>, array<T>) → array<T>',
  },
  {
    label: 'arrays_overlap',
    documentation:
      'Returns true if the arrays have common elements. Example: SELECT arrays_overlap(array[1, 2], array[2, 3]);',
    insertText: 'arrays_overlap',
    detail: 'arrays_overlap(array<T>, array<T>) → boolean',
  },
  {
    label: 'asin',
    documentation:
      'Returns the arc sine of a number. Example: SELECT asin(0.5);',
    insertText: 'asin',
    detail: 'asin(x) → double',
  },
  {
    label: 'AT TIME ZONE',
    documentation:
      "Converts a timestamp to a specified time zone. Example: SELECT timestamp '2020-01-01 00:00:00' AT TIME ZONE 'America/Los_Angeles';",
    insertText: 'AT TIME ZONE',
    detail: 'timestamp AT TIME ZONE time_zone',
  },
  {
    label: 'at_timezone',
    documentation:
      "Converts a timestamp to a specified time zone. Example: SELECT at_timezone(timestamp '2020-01-01 00:00:00', 'America/Los_Angeles');",
    insertText: 'at_timezone',
    detail: 'at_timezone(timestamp, time_zone) → timestamp',
  },
  {
    label: 'atan',
    documentation:
      'Returns the arc tangent of a number. Example: SELECT atan(1);',
    insertText: 'atan',
    detail: 'atan(x) → double',
  },
  {
    label: 'atan2',
    documentation:
      'Returns the arc tangent of y/x. Example: SELECT atan2(1, 1);',
    insertText: 'atan2',
    detail: 'atan2(y, x) → double',
  },
  {
    label: 'bar',
    documentation: 'Returns a vertical bar character. Example: SELECT bar();',
    insertText: 'bar',
    detail: 'bar() → varchar',
  },
  {
    label: 'beta_cdf',
    documentation:
      'Returns the cumulative beta distribution function. Example: SELECT beta_cdf(0.5, 1, 2);',
    insertText: 'beta_cdf',
    detail: 'beta_cdf(x, alpha, beta) → double',
  },
  {
    label: 'bing_tile',
    documentation:
      'Creates a Bing tile at a specified zoom level. Example: SELECT bing_tile(10, 20, 5);',
    insertText: 'bing_tile',
    detail: 'bing_tile(x, y, zoom_level) → BingTile',
  },
  {
    label: 'bing_tile_at',
    documentation:
      'Returns the Bing tile that contains the given latitude and longitude at the given zoom level. Example: SELECT bing_tile_at(10.0, 20.0, 15);',
    insertText: 'bing_tile_at',
    detail: 'bing_tile_at(latitude, longitude, zoom_level) → BingTile',
  },
  {
    label: 'bing_tile_coordinates',
    documentation:
      'Returns the coordinates of the Bing tile. Example: SELECT bing_tile_coordinates(tile);',
    insertText: 'bing_tile_coordinates',
    detail: 'bing_tile_coordinates(BingTile) → map(varchar, double)',
  },
  {
    label: 'bing_tile_polygon',
    documentation:
      'Returns the polygon that represents the Bing tile. Example: SELECT bing_tile_polygon(tile);',
    insertText: 'bing_tile_polygon',
    detail: 'bing_tile_polygon(BingTile) → Geometry',
  },
  {
    label: 'bing_tile_quadkey',
    documentation:
      'Returns the quadkey of the Bing tile. Example: SELECT bing_tile_quadkey(tile);',
    insertText: 'bing_tile_quadkey',
    detail: 'bing_tile_quadkey(BingTile) → varchar',
  },
  {
    label: 'bing_tile_zoom_level',
    documentation:
      'Returns the zoom level of the Bing tile. Example: SELECT bing_tile_zoom_level(tile);',
    insertText: 'bing_tile_zoom_level',
    detail: 'bing_tile_zoom_level(BingTile) → bigint',
  },
  {
    label: 'bing_tiles_around',
    documentation:
      'Returns the Bing tiles that cover the area within a certain radius of a point. Example: SELECT bing_tiles_around(10.0, 20.0, 5, 2);',
    insertText: 'bing_tiles_around',
    detail:
      'bing_tiles_around(latitude, longitude, radius, zoom_level) → array(BingTile)',
  },
  {
    label: 'bit_count',
    documentation:
      'Returns the number of bits set to 1 in the binary representation of a number. Example: SELECT bit_count(5);',
    insertText: 'bit_count',
    detail: 'bit_count(x) → bigint',
  },
  {
    label: 'bitwise_and',
    documentation:
      'Returns the bitwise AND of two numbers. Example: SELECT bitwise_and(5, 3);',
    insertText: 'bitwise_and',
    detail: 'bitwise_and(x, y) → bigint',
  },
  {
    label: 'bitwise_and_agg',
    documentation:
      'Returns the bitwise AND of all input values. Example: SELECT bitwise_and_agg(column) FROM table;',
    insertText: 'bitwise_and_agg',
    detail: 'bitwise_and_agg(x) → bigint',
  },
  {
    label: 'bitwise_left_shift',
    documentation:
      'Returns the result of a bitwise left shift. Example: SELECT bitwise_left_shift(1, 2);',
    insertText: 'bitwise_left_shift',
    detail: 'bitwise_left_shift(x, shift) → bigint',
  },
  {
    label: 'bitwise_not',
    documentation:
      'Returns the bitwise NOT of a number. Example: SELECT bitwise_not(5);',
    insertText: 'bitwise_not',
    detail: 'bitwise_not(x) → bigint',
  },
  {
    label: 'bitwise_or',
    documentation:
      'Returns the bitwise OR of two numbers. Example: SELECT bitwise_or(5, 3);',
    insertText: 'bitwise_or',
    detail: 'bitwise_or(x, y) → bigint',
  },
  {
    label: 'bitwise_or_agg',
    documentation:
      'Returns the bitwise OR of all input values. Example: SELECT bitwise_or_agg(column) FROM table;',
    insertText: 'bitwise_or_agg',
    detail: 'bitwise_or_agg(x) → bigint',
  },
  {
    label: 'bitwise_right_shift',
    documentation:
      'Returns the result of a bitwise right shift. Example: SELECT bitwise_right_shift(4, 1);',
    insertText: 'bitwise_right_shift',
    detail: 'bitwise_right_shift(x, shift) → bigint',
  },
  {
    label: 'bitwise_right_shift_arithmetic',
    documentation:
      'Returns the result of a bitwise arithmetic right shift. Example: SELECT bitwise_right_shift_arithmetic(4, 1);',
    insertText: 'bitwise_right_shift_arithmetic',
    detail: 'bitwise_right_shift_arithmetic(x, shift) → bigint',
  },
  {
    label: 'bitwise_xor',
    documentation:
      'Returns the bitwise XOR of two numbers. Example: SELECT bitwise_xor(5, 3);',
    insertText: 'bitwise_xor',
    detail: 'bitwise_xor(x, y) → bigint',
  },
  {
    label: 'bool_and',
    documentation:
      'Returns true if all input values are true. Example: SELECT bool_and(column) FROM table;',
    insertText: 'bool_and',
    detail: 'bool_and(x) → boolean',
  },
  {
    label: 'bool_or',
    documentation:
      'Returns true if any input value is true. Example: SELECT bool_or(column) FROM table;',
    insertText: 'bool_or',
    detail: 'bool_or(x) → boolean',
  },
  {
    label: 'cardinality',
    documentation:
      'Returns the number of elements in an array or map. Example: SELECT cardinality(array[1, 2, 3]);',
    insertText: 'cardinality',
    detail: 'cardinality(x) → bigint',
  },
  {
    label: 'cbrt',
    documentation:
      'Returns the cube root of a number. Example: SELECT cbrt(27);',
    insertText: 'cbrt',
    detail: 'cbrt(x) → double',
  },
  {
    label: 'ceil',
    documentation:
      'Returns the smallest integer greater than or equal to a number. Example: SELECT ceil(1.5);',
    insertText: 'ceil',
    detail: 'ceil(x) → double',
  },
  {
    label: 'ceiling',
    documentation:
      'Returns the smallest integer greater than or equal to a number. Example: SELECT ceiling(1.5);',
    insertText: 'ceiling',
    detail: 'ceiling(x) → double',
  },
  {
    label: 'char2hexint',
    documentation:
      "Returns the hexadecimal representation of a character. Example: SELECT char2hexint('A');",
    insertText: 'char2hexint',
    detail: 'char2hexint(char) → int',
  },
  {
    label: 'checksum',
    documentation:
      'Returns a checksum of a value. Example: SELECT checksum(column) FROM table;',
    insertText: 'checksum',
    detail: 'checksum(x) → bigint',
  },
  {
    label: 'chr',
    documentation:
      'Returns the character with the specified ASCII code. Example: SELECT chr(65);',
    insertText: 'chr',
    detail: 'chr(x) → varchar',
  },
  {
    label: 'classify',
    documentation:
      'Returns the classification label for a given row based on a classifier model. Example: SELECT classify(model, row);',
    insertText: 'classify',
    detail: 'classify(model, row) → varchar',
  },
  {
    label: 'classifier',
    documentation:
      "Represents a classifier model. Example: SELECT classifier('model_name');",
    insertText: 'classifier',
    detail: 'classifier(model_name) → classifier',
  },
  {
    label: 'codepoint',
    documentation:
      "Returns the Unicode code point of the first character of the string. Example: SELECT codepoint('A');",
    insertText: 'codepoint',
    detail: 'codepoint(string) → int',
  },
  {
    label: 'color',
    documentation:
      "Returns a color value from a string. Example: SELECT color('red');",
    insertText: 'color',
    detail: 'color(string) → color',
  },
  {
    label: 'combinations',
    documentation:
      'Returns an array of all combinations of the elements of an array. Example: SELECT combinations(array[1, 2, 3], 2);',
    insertText: 'combinations',
    detail: 'combinations(array, k) → array',
  },
  {
    label: 'concat',
    documentation:
      "Concatenates two or more strings. Example: SELECT concat('Hello', ' ', 'World');",
    insertText: 'concat',
    detail: 'concat(string1, string2, ...) → varchar',
  },
  {
    label: 'concat_ws',
    documentation:
      "Concatenates two or more strings with a separator. Example: SELECT concat_ws(',', 'a', 'b', 'c');",
    insertText: 'concat_ws',
    detail: 'concat_ws(separator, string1, string2, ...) → varchar',
  },
  {
    label: 'contains_sequence',
    documentation:
      'Returns true if an array contains a sequence of elements. Example: SELECT contains_sequence(array[1, 2, 3], array[2, 3]);',
    insertText: 'contains_sequence',
    detail: 'contains_sequence(array, sequence) → boolean',
  },
  {
    label: 'convex_hull_agg',
    documentation:
      'Returns the convex hull of the input geometries. Example: SELECT convex_hull_agg(geometry) FROM table;',
    insertText: 'convex_hull_agg',
    detail: 'convex_hull_agg(x) → Geometry',
  },
  {
    label: 'corr',
    documentation:
      'Returns the correlation coefficient of a set of numbers. Example: SELECT corr(column1, column2) FROM table;',
    insertText: 'corr',
    detail: 'corr(x, y) → double',
  },
  {
    label: 'cos',
    documentation: 'Returns the cosine of a number. Example: SELECT cos(0);',
    insertText: 'cos',
    detail: 'cos(x) → double',
  },
  {
    label: 'cosh',
    documentation:
      'Returns the hyperbolic cosine of a number. Example: SELECT cosh(0);',
    insertText: 'cosh',
    detail: 'cosh(x) → double',
  },
  {
    label: 'cosine_similarity',
    documentation:
      'Returns the cosine similarity between two vectors. Example: SELECT cosine_similarity(array[1, 2, 3], array[4, 5, 6]);',
    insertText: 'cosine_similarity',
    detail: 'cosine_similarity(array1, array2) → double',
  },
  {
    label: 'count_if',
    documentation:
      'Returns the number of input values that satisfy a condition. Example: SELECT count_if(column > 1) FROM table;',
    insertText: 'count_if',
    detail: 'count_if(x) → bigint',
  },
  {
    label: 'covar_pop',
    documentation:
      'Returns the population covariance of a set of numbers. Example: SELECT covar_pop(column1, column2) FROM table;',
    insertText: 'covar_pop',
    detail: 'covar_pop(x, y) → double',
  },
  {
    label: 'covar_samp',
    documentation:
      'Returns the sample covariance of a set of numbers. Example: SELECT covar_samp(column1, column2) FROM table;',
    insertText: 'covar_samp',
    detail: 'covar_samp(x, y) → double',
  },
  {
    label: 'crc32',
    documentation:
      "Returns the CRC32 checksum of a string. Example: SELECT crc32('Hello, World');",
    insertText: 'crc32',
    detail: 'crc32(string) → bigint',
  },
  {
    label: 'cume_dist',
    documentation:
      'Returns the cumulative distribution of a value within a window. Example: SELECT cume_dist() OVER (PARTITION BY column ORDER BY column);',
    insertText: 'cume_dist',
    detail: 'cume_dist() → double',
  },
  {
    label: 'current_groups',
    documentation:
      'Returns the current groups. Example: SELECT current_groups();',
    insertText: 'current_groups',
    detail: 'current_groups() → array(varchar)',
  },
  {
    label: 'current_timezone',
    documentation:
      'Returns the current time zone. Example: SELECT current_timezone();',
    insertText: 'current_timezone',
    detail: 'current_timezone() → varchar',
  },
  {
    label: 'date_add',
    documentation:
      "Adds an interval to a date. Example: SELECT date_add('day', 1, date('2023-01-01'));",
    insertText: 'date_add',
    detail: 'date_add(unit, value, timestamp) → timestamp',
  },
  {
    label: 'date_diff',
    documentation:
      "Calculates the difference between two dates. Example: SELECT date_diff('day', date('2023-01-01'), date('2023-01-10'));",
    insertText: 'date_diff',
    detail: 'date_diff(unit, date1, date2) → bigint',
  },
  {
    label: 'date_format',
    documentation:
      "Formats a date as a string. Example: SELECT date_format(date('2023-01-01'), '%Y-%m-%d');",
    insertText: 'date_format',
    detail: 'date_format(timestamp, format) → varchar',
  },
  {
    label: 'date_parse',
    documentation:
      "Parses a date from a string. Example: SELECT date_parse('2023-01-01', '%Y-%m-%d');",
    insertText: 'date_parse',
    detail: 'date_parse(string, format) → timestamp',
  },
  {
    label: 'date_trunc',
    documentation:
      "Truncates a date to a specified precision. Example: SELECT date_trunc('day', date('2023-01-01'));",
    insertText: 'date_trunc',
    detail: 'date_trunc(unit, timestamp) → timestamp',
  },
  {
    label: 'day_of_month',
    documentation:
      "Returns the day of the month from a date. Example: SELECT day_of_month(date('2023-01-01'));",
    insertText: 'day_of_month',
    detail: 'day_of_month(x) → bigint',
  },
  {
    label: 'day_of_week',
    documentation:
      "Returns the day of the week from a date. Example: SELECT day_of_week(date('2023-01-01'));",
    insertText: 'day_of_week',
    detail: 'day_of_week(x) → bigint',
  },
  {
    label: 'day_of_year',
    documentation:
      "Returns the day of the year from a date. Example: SELECT day_of_year(date('2023-01-01'));",
    insertText: 'day_of_year',
    detail: 'day_of_year(x) → bigint',
  },
  {
    label: 'degrees',
    documentation:
      'Converts an angle from radians to degrees. Example: SELECT degrees(pi());',
    insertText: 'degrees',
    detail: 'degrees(x) → double',
  },
  {
    label: 'dense_rank',
    documentation:
      'Returns the dense rank of a value within a window. Example: SELECT dense_rank() OVER (PARTITION BY column ORDER BY column);',
    insertText: 'dense_rank',
    detail: 'dense_rank() → bigint',
  },
  {
    label: 'div',
    documentation:
      'Returns the integer division of two numbers. Example: SELECT div(5, 2);',
    insertText: 'div',
    detail: 'div(x, y) → bigint',
  },
  {
    label: 'dot_product',
    documentation:
      'Returns the dot product of two vectors. Example: SELECT dot_product(array[1, 2, 3], array[4, 5, 6]);',
    insertText: 'dot_product',
    detail: 'dot_product(array1, array2) → double',
  },
  {
    label: 'E',
    documentation:
      'Returns the value of the mathematical constant e. Example: SELECT E();',
    insertText: 'E',
    detail: 'E() → double',
  },
  {
    label: 'element_at',
    documentation:
      'Returns the element of an array or map at a specified position. Example: SELECT element_at(array[1, 2, 3], 2);',
    insertText: 'element_at',
    detail: 'element_at(array, index) → value',
  },
  {
    label: 'empty_approx_set',
    documentation:
      'Returns an empty approximate set. Example: SELECT empty_approx_set();',
    insertText: 'empty_approx_set',
    detail: 'empty_approx_set() → HyperLogLog',
  },
  {
    label: 'ends_with',
    documentation:
      "Returns true if a string ends with a specified substring. Example: SELECT ends_with('Hello, World', 'World');",
    insertText: 'ends_with',
    detail: 'ends_with(string, substring) → boolean',
  },
  {
    label: 'equal_arrays',
    documentation:
      'Returns true if two arrays are equal. Example: SELECT equal_arrays(array[1, 2], array[1, 2]);',
    insertText: 'equal_arrays',
    detail: 'equal_arrays(array1, array2) → boolean',
  },
  {
    label: 'every',
    documentation:
      'Returns true if all input values are true. Example: SELECT every(column) FROM table;',
    insertText: 'every',
    detail: 'every(x) → boolean',
  },
  {
    label: 'exp',
    documentation:
      'Returns e raised to the power of a number. Example: SELECT exp(1);',
    insertText: 'exp',
    detail: 'exp(x) → double',
  },
  {
    label: 'first_value',
    documentation:
      'Returns the first value in a window. Example: SELECT first_value(column) OVER (PARTITION BY column ORDER BY column);',
    insertText: 'first_value',
    detail: 'first_value(x) → value',
  },
  {
    label: 'flatten',
    documentation:
      'Flattens an array of arrays. Example: SELECT flatten(array[array[1, 2], array[3, 4]]);',
    insertText: 'flatten',
    detail: 'flatten(array) → array',
  },
  {
    label: 'floor',
    documentation:
      'Returns the largest integer less than or equal to a number. Example: SELECT floor(1.5);',
    insertText: 'floor',
    detail: 'floor(x) → double',
  },
  {
    label: 'format_datetime',
    documentation:
      "Formats a timestamp as a string. Example: SELECT format_datetime(current_timestamp, 'yyyy-MM-dd HH:mm:ss');",
    insertText: 'format_datetime',
    detail: 'format_datetime(timestamp, format) → varchar',
  },
  {
    label: 'from_base64',
    documentation:
      "Decodes a base64 encoded string. Example: SELECT from_base64('SGVsbG8sIFdvcmxk');",
    insertText: 'from_base64',
    detail: 'from_base64(string) → varbinary',
  },
  {
    label: 'from_base64url',
    documentation:
      "Decodes a base64 URL encoded string. Example: SELECT from_base64url('SGVsbG8sIFdvcmxk');",
    insertText: 'from_base64url',
    detail: 'from_base64url(string) → varbinary',
  },
  {
    label: 'from_hex',
    documentation:
      "Decodes a hexadecimal encoded string. Example: SELECT from_hex('48656c6c6f2c20576f726c64');",
    insertText: 'from_hex',
    detail: 'from_hex(string) → varbinary',
  },
  {
    label: 'from_iso8601_date',
    documentation:
      "Converts an ISO 8601 date string to a date. Example: SELECT from_iso8601_date('2023-01-01');",
    insertText: 'from_iso8601_date',
    detail: 'from_iso8601_date(string) → date',
  },
  {
    label: 'from_iso8601_timestamp',
    documentation:
      "Converts an ISO 8601 timestamp string to a timestamp. Example: SELECT from_iso8601_timestamp('2023-01-01T00:00:00Z');",
    insertText: 'from_iso8601_timestamp',
    detail: 'from_iso8601_timestamp(string) → timestamp',
  },
  {
    label: 'from_unixtime',
    documentation:
      'Converts a UNIX timestamp to a timestamp. Example: SELECT from_unixtime(1672531199);',
    insertText: 'from_unixtime',
    detail: 'from_unixtime(epoch) → timestamp',
  },
  {
    label: 'gamma',
    documentation:
      'Returns the gamma function value of a number. Example: SELECT gamma(5);',
    insertText: 'gamma',
    detail: 'gamma(x) → double',
  },
  {
    label: 'geography',
    documentation:
      "Represents a geographical object. Example: SELECT geography('POINT (1 2)');",
    insertText: 'geography',
    detail: 'geography(string) → Geography',
  },
  {
    label: 'geometry',
    documentation:
      "Represents a geometrical object. Example: SELECT geometry('POINT (1 2)');",
    insertText: 'geometry',
    detail: 'geometry(string) → Geometry',
  },
  {
    label: 'greatest',
    documentation:
      'Returns the greatest value from a list of values. Example: SELECT greatest(1, 2, 3);',
    insertText: 'greatest',
    detail: 'greatest(value1, value2, ...) → value',
  },
  {
    label: 'grouping',
    documentation:
      'Indicates if a column is aggregated in a GROUP BY query. Example: SELECT grouping(column) FROM table GROUP BY column WITH ROLLUP;',
    insertText: 'grouping',
    detail: 'grouping(x) → bigint',
  },
  {
    label: 'grouping_id',
    documentation:
      'Returns the grouping ID of a GROUP BY query with ROLLUP or CUBE. Example: SELECT grouping_id(column1, column2) FROM table GROUP BY column1, column2 WITH ROLLUP;',
    insertText: 'grouping_id',
    detail: 'grouping_id(column1, column2, ...) → bigint',
  },
  {
    label: 'has_role',
    documentation:
      "Returns true if the current user has a specified role. Example: SELECT has_role('admin');",
    insertText: 'has_role',
    detail: 'has_role(role) → boolean',
  },
  {
    label: 'has_substr',
    documentation:
      "Returns true if a string contains a specified substring. Example: SELECT has_substr('Hello, World', 'World');",
    insertText: 'has_substr',
    detail: 'has_substr(string, substring) → boolean',
  },
  {
    label: 'hash',
    documentation:
      "Returns the hash value of a string. Example: SELECT hash('Hello, World');",
    insertText: 'hash',
    detail: 'hash(string) → varbinary',
  },
  {
    label: 'hex',
    documentation:
      "Encodes a string as hexadecimal. Example: SELECT hex('Hello, World');",
    insertText: 'hex',
    detail: 'hex(string) → varchar',
  },
  {
    label: 'highest',
    documentation:
      'Returns the highest value from a list of values. Example: SELECT highest(1, 2, 3);',
    insertText: 'highest',
    detail: 'highest(value1, value2, ...) → value',
  },
  {
    label: 'histogram',
    documentation:
      'Returns a histogram of the input values. Example: SELECT histogram(column) FROM table;',
    insertText: 'histogram',
    detail: 'histogram(x) → map',
  },
  {
    label: 'hours',
    documentation:
      "Returns the hour from a timestamp. Example: SELECT hours(timestamp '2023-01-01 00:00:00');",
    insertText: 'hours',
    detail: 'hours(x) → bigint',
  },
  {
    label: 'hll_cardinality',
    documentation:
      'Returns the cardinality of a HyperLogLog. Example: SELECT hll_cardinality(approx_set(column)) FROM table;',
    insertText: 'hll_cardinality',
    detail: 'hll_cardinality(x) → bigint',
  },
  {
    label: 'hll_merge',
    documentation:
      'Merges multiple HyperLogLogs into one. Example: SELECT hll_merge(approx_set(column)) FROM table;',
    insertText: 'hll_merge',
    detail: 'hll_merge(x) → HyperLogLog',
  },
  {
    label: 'hll_union',
    documentation:
      'Unions multiple HyperLogLogs into one. Example: SELECT hll_union(approx_set(column)) FROM table;',
    insertText: 'hll_union',
    detail: 'hll_union(x) → HyperLogLog',
  },
  {
    label: 'hyperloglog',
    documentation:
      'Returns a HyperLogLog data structure. Example: SELECT hyperloglog(column) FROM table;',
    insertText: 'hyperloglog',
    detail: 'hyperloglog(x) → HyperLogLog',
  },
  {
    label: 'hypot',
    documentation:
      'Returns the hypotenuse of a right-angled triangle. Example: SELECT hypot(3, 4);',
    insertText: 'hypot',
    detail: 'hypot(x, y) → double',
  },
  {
    label: 'id_for',
    documentation:
      'Returns the unique identifier for a row in a table. Example: SELECT id_for(column) FROM table;',
    insertText: 'id_for',
    detail: 'id_for(x) → bigint',
  },
  {
    label: 'if_bound',
    documentation:
      "Returns a value based on a condition and boundary. Example: SELECT if_bound(column > 1, 'true', 'false');",
    insertText: 'if_bound',
    detail: 'if_bound(condition, true_value, false_value) → value',
  },
  {
    label: 'if_not_bound',
    documentation:
      "Returns a value based on a condition and boundary. Example: SELECT if_not_bound(column > 1, 'true', 'false');",
    insertText: 'if_not_bound',
    detail: 'if_not_bound(condition, true_value, false_value) → value',
  },
  {
    label: 'ifnull',
    documentation:
      "Returns the first non-null value from a list of arguments. Example: SELECT ifnull(null, 'a', 'b');",
    insertText: 'ifnull',
    detail: 'ifnull(value1, value2, ...) → value',
  },
  {
    label: 'ilike',
    documentation:
      "Returns true if a string matches a pattern case-insensitively. Example: SELECT ilike('Hello, World', '%world%');",
    insertText: 'ilike',
    detail: 'ilike(string, pattern) → boolean',
  },
  {
    label: 'inet_aton',
    documentation:
      "Converts an IP address to a number. Example: SELECT inet_aton('127.0.0.1');",
    insertText: 'inet_aton',
    detail: 'inet_aton(string) → bigint',
  },
  {
    label: 'inet_ntoa',
    documentation:
      'Converts a number to an IP address. Example: SELECT inet_ntoa(2130706433);',
    insertText: 'inet_ntoa',
    detail: 'inet_ntoa(bigint) → varchar',
  },
  {
    label: 'infinity',
    documentation:
      'Returns the value of positive infinity. Example: SELECT infinity();',
    insertText: 'infinity',
    detail: 'infinity() → double',
  },
  {
    label: 'intersection',
    documentation:
      'Returns the intersection of two arrays. Example: SELECT intersection(array[1, 2, 3], array[2, 3, 4]);',
    insertText: 'intersection',
    detail: 'intersection(array1, array2) → array',
  },
  {
    label: 'is_finite',
    documentation:
      'Returns true if a number is finite. Example: SELECT is_finite(1.23);',
    insertText: 'is_finite',
    detail: 'is_finite(x) → boolean',
  },
  {
    label: 'is_infinite',
    documentation:
      'Returns true if a number is infinite. Example: SELECT is_infinite(infinity());',
    insertText: 'is_infinite',
    detail: 'is_infinite(x) → boolean',
  },
  {
    label: 'is_json_scalar',
    documentation:
      'Returns true if a JSON value is a scalar. Example: SELECT is_json_scalar(json_parse(\'"Hello, World"\'));',
    insertText: 'is_json_scalar',
    detail: 'is_json_scalar(json) → boolean',
  },
  {
    label: 'is_nan',
    documentation:
      'Returns true if a number is NaN. Example: SELECT is_nan(nan());',
    insertText: 'is_nan',
    detail: 'is_nan(x) → boolean',
  },
  {
    label: 'is_null',
    documentation:
      'Returns true if a value is null. Example: SELECT is_null(column) FROM table;',
    insertText: 'is_null',
    detail: 'is_null(x) → boolean',
  },
  {
    label: 'is_valid_json',
    documentation:
      'Returns true if a string is valid JSON. Example: SELECT is_valid_json(\'{"key": "value"}\');',
    insertText: 'is_valid_json',
    detail: 'is_valid_json(string) → boolean',
  },
  {
    label: 'is_valid_timezone',
    documentation:
      "Returns true if a string is a valid timezone. Example: SELECT is_valid_timezone('UTC');",
    insertText: 'is_valid_timezone',
    detail: 'is_valid_timezone(string) → boolean',
  },
  {
    label: 'isnotnull',
    documentation:
      'Returns true if a value is not null. Example: SELECT isnotnull(column) FROM table;',
    insertText: 'isnotnull',
    detail: 'isnotnull(x) → boolean',
  },
  {
    label: 'json_array_get',
    documentation:
      "Returns an element from a JSON array. Example: SELECT json_array_get(json_parse('[1, 2, 3]'), 1);",
    insertText: 'json_array_get',
    detail: 'json_array_get(json, index) → json',
  },
  {
    label: 'json_array_length',
    documentation:
      "Returns the length of a JSON array. Example: SELECT json_array_length(json_parse('[1, 2, 3]'));",
    insertText: 'json_array_length',
    detail: 'json_array_length(json) → bigint',
  },
  {
    label: 'json_extract',
    documentation:
      'Extracts a value from a JSON object. Example: SELECT json_extract(json_parse(\'{"key": "value"}\'), \'$.key\');',
    insertText: 'json_extract',
    detail: 'json_extract(json, json_path) → json',
  },
  {
    label: 'json_extract_scalar',
    documentation:
      'Extracts a scalar value from a JSON object. Example: SELECT json_extract_scalar(json_parse(\'{"key": "value"}\'), \'$.key\');',
    insertText: 'json_extract_scalar',
    detail: 'json_extract_scalar(json, json_path) → varchar',
  },
  {
    label: 'json_parse',
    documentation:
      'Parses a JSON string into a JSON object. Example: SELECT json_parse(\'{"key": "value"}\');',
    insertText: 'json_parse',
    detail: 'json_parse(string) → json',
  },
  {
    label: 'json_serialize',
    documentation:
      'Serializes a JSON object to a string. Example: SELECT json_serialize(json_parse(\'{"key": "value"}\'));',
    insertText: 'json_serialize',
    detail: 'json_serialize(json) → varchar',
  },
  {
    label: 'kurtosis',
    documentation:
      'Returns the kurtosis of a set of values. Example: SELECT kurtosis(column) FROM table;',
    insertText: 'kurtosis',
    detail: 'kurtosis(x) → double',
  },
  {
    label: 'lag',
    documentation:
      'Returns the value of a column at a specified offset before the current row in a window. Example: SELECT lag(column, 1) OVER (ORDER BY column);',
    insertText: 'lag',
    detail: 'lag(x, offset, default_value) → value',
  },
  {
    label: 'last_value',
    documentation:
      'Returns the last value in a window. Example: SELECT last_value(column) OVER (PARTITION BY column ORDER BY column);',
    insertText: 'last_value',
    detail: 'last_value(x) → value',
  },
  {
    label: 'lcase',
    documentation:
      "Returns the lower case version of a string. Example: SELECT lcase('HELLO');",
    insertText: 'lcase',
    detail: 'lcase(string) → varchar',
  },
  {
    label: 'lead',
    documentation:
      'Returns the value of a column at a specified offset after the current row in a window. Example: SELECT lead(column, 1) OVER (ORDER BY column);',
    insertText: 'lead',
    detail: 'lead(x, offset, default_value) → value',
  },
  {
    label: 'least',
    documentation:
      'Returns the least value from a list of values. Example: SELECT least(1, 2, 3);',
    insertText: 'least',
    detail: 'least(value1, value2, ...) → value',
  },
  {
    label: 'length',
    documentation:
      "Returns the length of a string. Example: SELECT length('Hello, World');",
    insertText: 'length',
    detail: 'length(string) → bigint',
  },
  {
    label: 'ln',
    documentation:
      'Returns the natural logarithm of a number. Example: SELECT ln(1);',
    insertText: 'ln',
    detail: 'ln(x) → double',
  },
  {
    label: 'localtimestamp',
    documentation:
      'Returns the current date and time. Example: SELECT localtimestamp;',
    insertText: 'localtimestamp',
    detail: 'localtimestamp() → timestamp',
  },
  {
    label: 'log',
    documentation:
      'Returns the logarithm of a number. Example: SELECT log(10, 100);',
    insertText: 'log',
    detail: 'log(base, x) → double',
  },
  {
    label: 'log10',
    documentation:
      'Returns the base-10 logarithm of a number. Example: SELECT log10(100);',
    insertText: 'log10',
    detail: 'log10(x) → double',
  },
  {
    label: 'log2',
    documentation:
      'Returns the base-2 logarithm of a number. Example: SELECT log2(4);',
    insertText: 'log2',
    detail: 'log2(x) → double',
  },
  {
    label: 'lpad',
    documentation:
      "Pads a string on the left with a specified character. Example: SELECT lpad('Hello', 10, ' ');",
    insertText: 'lpad',
    detail: 'lpad(string, length, padstring) → varchar',
  },
  {
    label: 'ltrim',
    documentation:
      "Removes leading spaces from a string. Example: SELECT ltrim('   Hello');",
    insertText: 'ltrim',
    detail: 'ltrim(string) → varchar',
  },
  {
    label: 'map',
    documentation:
      "Creates a map from a list of keys and values. Example: SELECT map(array['key1', 'key2'], array['value1', 'value2']);",
    insertText: 'map',
    detail: 'map(keys, values) → map',
  },
  {
    label: 'map_concat',
    documentation:
      "Concatenates two maps. Example: SELECT map_concat(map(array['key1'], array['value1']), map(array['key2'], array['value2']));",
    insertText: 'map_concat',
    detail: 'map_concat(map1, map2) → map',
  },
  {
    label: 'map_entries',
    documentation:
      "Returns the entries of a map as an array of key-value pairs. Example: SELECT map_entries(map(array['key1'], array['value1']));",
    insertText: 'map_entries',
    detail: 'map_entries(map) → array',
  },
  {
    label: 'map_filter',
    documentation:
      "Filters the entries of a map based on a condition. Example: SELECT map_filter(map(array['key1', 'key2'], array['value1', 'value2']), (key, value) -> key = 'key1');",
    insertText: 'map_filter',
    detail: 'map_filter(map, function) → map',
  },
  {
    label: 'map_keys',
    documentation:
      "Returns the keys of a map as an array. Example: SELECT map_keys(map(array['key1'], array['value1']));",
    insertText: 'map_keys',
    detail: 'map_keys(map) → array',
  },
  {
    label: 'map_values',
    documentation:
      "Returns the values of a map as an array. Example: SELECT map_values(map(array['key1'], array['value1']));",
    insertText: 'map_values',
    detail: 'map_values(map) → array',
  },
  {
    label: 'match_all_positions',
    documentation:
      "Returns all positions of a substring in a string. Example: SELECT match_all_positions('Hello, World', 'l');",
    insertText: 'match_all_positions',
    detail: 'match_all_positions(string, substring) → array',
  },
  {
    label: 'match_recognize',
    documentation:
      "Matches a regular expression in a string. Example: SELECT match_recognize('Hello, World', '.*World.*');",
    insertText: 'match_recognize',
    detail: 'match_recognize(string, pattern) → array',
  },
  {
    label: 'max_by',
    documentation:
      'Returns the maximum value from a list of values by a specified key. Example: SELECT max_by(column1, column2) FROM table;',
    insertText: 'max_by',
    detail: 'max_by(value, key) → value',
  },
  {
    label: 'md5',
    documentation:
      "Returns the MD5 hash of a string. Example: SELECT md5('Hello, World');",
    insertText: 'md5',
    detail: 'md5(string) → varbinary',
  },
  {
    label: 'min_by',
    documentation:
      'Returns the minimum value from a list of values by a specified key. Example: SELECT min_by(column1, column2) FROM table;',
    insertText: 'min_by',
    detail: 'min_by(value, key) → value',
  },
  {
    label: 'minutes',
    documentation:
      "Returns the minute from a timestamp. Example: SELECT minutes(timestamp '2023-01-01 00:00:00');",
    insertText: 'minutes',
    detail: 'minutes(x) → bigint',
  },
  {
    label: 'mod',
    documentation:
      'Returns the remainder of a division operation. Example: SELECT mod(10, 3);',
    insertText: 'mod',
    detail: 'mod(x, y) → bigint',
  },
  {
    label: 'mode',
    documentation:
      'Returns the mode (most frequent value) of a set of values. Example: SELECT mode(column) FROM table;',
    insertText: 'mode',
    detail: 'mode(x) → value',
  },
  {
    label: 'months',
    documentation:
      "Returns the month from a timestamp. Example: SELECT months(timestamp '2023-01-01 00:00:00');",
    insertText: 'months',
    detail: 'months(x) → bigint',
  },
  {
    label: 'nan',
    documentation:
      'Returns the value of NaN (not a number). Example: SELECT nan();',
    insertText: 'nan',
    detail: 'nan() → double',
  },
  {
    label: 'network_sort',
    documentation:
      "Sorts an array of IP addresses. Example: SELECT network_sort(array['192.168.0.1', '10.0.0.1']);",
    insertText: 'network_sort',
    detail: 'network_sort(array) → array',
  },
  {
    label: 'network_subset',
    documentation:
      "Returns true if an IP address is within a subnet. Example: SELECT network_subset('192.168.0.1', '192.168.0.0/24');",
    insertText: 'network_subset',
    detail: 'network_subset(ip, subnet) → boolean',
  },
  {
    label: 'next_month',
    documentation:
      "Returns the date of the next month. Example: SELECT next_month(date '2023-01-01');",
    insertText: 'next_month',
    detail: 'next_month(date) → date',
  },
  {
    label: 'next_week',
    documentation:
      "Returns the date of the next week. Example: SELECT next_week(date '2023-01-01');",
    insertText: 'next_week',
    detail: 'next_week(date) → date',
  },
  {
    label: 'next_year',
    documentation:
      "Returns the date of the next year. Example: SELECT next_year(date '2023-01-01');",
    insertText: 'next_year',
    detail: 'next_year(date) → date',
  },
  {
    label: 'nth_value',
    documentation:
      'Returns the nth value in a window. Example: SELECT nth_value(column, 2) OVER (PARTITION BY column ORDER BY column);',
    insertText: 'nth_value',
    detail: 'nth_value(x, n) → value',
  },
  {
    label: 'ntile',
    documentation:
      'Divides the rows of a window into a specified number of groups and assigns a number to each row to indicate its group. Example: SELECT ntile(4) OVER (PARTITION BY column ORDER BY column);',
    insertText: 'ntile',
    detail: 'ntile(x) → bigint',
  },
  {
    label: 'nullifzero',
    documentation:
      'Returns null if a value is zero. Example: SELECT nullifzero(column);',
    insertText: 'nullifzero',
    detail: 'nullifzero(value) → value',
  },
  {
    label: 'object_construct',
    documentation:
      "Constructs an object from a list of key-value pairs. Example: SELECT object_construct('key1', 'value1', 'key2', 'value2');",
    insertText: 'object_construct',
    detail: 'object_construct(key1, value1, key2, value2, ...) → object',
  },
  {
    label: 'object_delete_key',
    documentation:
      "Deletes a key from an object. Example: SELECT object_delete_key(object_construct('key1', 'value1'), 'key1');",
    insertText: 'object_delete_key',
    detail: 'object_delete_key(object, key) → object',
  },
  {
    label: 'object_keys',
    documentation:
      "Returns the keys of an object as an array. Example: SELECT object_keys(object_construct('key1', 'value1'));",
    insertText: 'object_keys',
    detail: 'object_keys(object) → array',
  },
  {
    label: 'object_values',
    documentation:
      "Returns the values of an object as an array. Example: SELECT object_values(object_construct('key1', 'value1'));",
    insertText: 'object_values',
    detail: 'object_values(object) → array',
  },
  {
    label: 'ordinal',
    documentation:
      'Returns the ordinal (1-based) index of a value in an array. Example: SELECT ordinal(array[1, 2, 3], 2);',
    insertText: 'ordinal',
    detail: 'ordinal(array, value) → bigint',
  },
  {
    label: 'overlay',
    documentation:
      "Replaces a substring of a string with another string. Example: SELECT overlay('Hello, World', 'Universe', 8);",
    insertText: 'overlay',
    detail: 'overlay(string, replacement, start) → varchar',
  },
  {
    label: 'parse_json',
    documentation:
      'Parses a JSON string into a JSON object. Example: SELECT parse_json(\'{"key": "value"}\');',
    insertText: 'parse_json',
    detail: 'parse_json(string) → json',
  },
  {
    label: 'percent_rank',
    documentation:
      'Returns the percent rank of a value in a window. Example: SELECT percent_rank() OVER (PARTITION BY column ORDER BY column);',
    insertText: 'percent_rank',
    detail: 'percent_rank() → double',
  },
  {
    label: 'percentile_cont',
    documentation:
      'Returns the value at a specified percentile. Example: SELECT percentile_cont(0.5) WITHIN GROUP (ORDER BY column);',
    insertText: 'percentile_cont',
    detail: 'percentile_cont(percentile) WITHIN GROUP (ORDER BY x) → double',
  },
  {
    label: 'percentile_disc',
    documentation:
      'Returns the value at a specified percentile. Example: SELECT percentile_disc(0.5) WITHIN GROUP (ORDER BY column);',
    insertText: 'percentile_disc',
    detail: 'percentile_disc(percentile) WITHIN GROUP (ORDER BY x) → double',
  },
  {
    label: 'pi',
    documentation: 'Returns the value of pi. Example: SELECT pi();',
    insertText: 'pi',
    detail: 'pi() → double',
  },
  {
    label: 'pow',
    documentation:
      'Returns the result of raising a number to a power. Example: SELECT pow(2, 3);',
    insertText: 'pow',
    detail: 'pow(base, exponent) → double',
  },
  {
    label: 'power',
    documentation:
      'Returns the result of raising a number to a power. Example: SELECT power(2, 3);',
    insertText: 'power',
    detail: 'power(base, exponent) → double',
  },
  {
    label: 'quarter',
    documentation:
      "Returns the quarter from a timestamp. Example: SELECT quarter(timestamp '2023-01-01 00:00:00');",
    insertText: 'quarter',
    detail: 'quarter(x) → bigint',
  },
  {
    label: 'quantile',
    documentation:
      'Returns the value at a specified quantile. Example: SELECT quantile(0.5) WITHIN GROUP (ORDER BY column);',
    insertText: 'quantile',
    detail: 'quantile(quantile) WITHIN GROUP (ORDER BY x) → double',
  },
  {
    label: 'rand',
    documentation:
      'Returns a random number between 0 and 1. Example: SELECT rand();',
    insertText: 'rand',
    detail: 'rand() → double',
  },
  {
    label: 'rank',
    documentation:
      'Returns the rank of a value in a window. Example: SELECT rank() OVER (PARTITION BY column ORDER BY column);',
    insertText: 'rank',
    detail: 'rank() → bigint',
  },
  {
    label: 'regexp_extract',
    documentation:
      "Extracts a substring from a string using a regular expression. Example: SELECT regexp_extract('Hello, World', 'W.*d');",
    insertText: 'regexp_extract',
    detail: 'regexp_extract(string, pattern) → varchar',
  },
  {
    label: 'regexp_replace',
    documentation:
      "Replaces substrings in a string that match a regular expression. Example: SELECT regexp_replace('Hello, World', 'World', 'Universe');",
    insertText: 'regexp_replace',
    detail: 'regexp_replace(string, pattern, replacement) → varchar',
  },
  {
    label: 'repeat',
    documentation:
      "Repeats a string a specified number of times. Example: SELECT repeat('Hello', 3);",
    insertText: 'repeat',
    detail: 'repeat(string, count) → varchar',
  },
  {
    label: 'reverse',
    documentation:
      "Reverses a string. Example: SELECT reverse('Hello, World');",
    insertText: 'reverse',
    detail: 'reverse(string) → varchar',
  },
  {
    label: 'round',
    documentation:
      'Rounds a number to a specified number of decimal places. Example: SELECT round(1.2345, 2);',
    insertText: 'round',
    detail: 'round(x, d) → double',
  },
  {
    label: 'row_number',
    documentation:
      'Returns the row number of a row in a window. Example: SELECT row_number() OVER (PARTITION BY column ORDER BY column);',
    insertText: 'row_number',
    detail: 'row_number() → bigint',
  },
  {
    label: 'rpad',
    documentation:
      "Pads a string on the right with a specified character. Example: SELECT rpad('Hello', 10, ' ');",
    insertText: 'rpad',
    detail: 'rpad(string, length, padstring) → varchar',
  },
  {
    label: 'rtrim',
    documentation:
      "Removes trailing spaces from a string. Example: SELECT rtrim('Hello   ');",
    insertText: 'rtrim',
    detail: 'rtrim(string) → varchar',
  },
  {
    label: 'seconds',
    documentation:
      "Returns the second from a timestamp. Example: SELECT seconds(timestamp '2023-01-01 00:00:00');",
    insertText: 'seconds',
    detail: 'seconds(x) → bigint',
  },
  {
    label: 'sequence',
    documentation:
      'Returns a sequence of numbers. Example: SELECT sequence(1, 10);',
    insertText: 'sequence',
    detail: 'sequence(start, stop) → array',
  },
  {
    label: 'sha1',
    documentation:
      "Returns the SHA-1 hash of a string. Example: SELECT sha1('Hello, World');",
    insertText: 'sha1',
    detail: 'sha1(string) → varbinary',
  },
  {
    label: 'sha256',
    documentation:
      "Returns the SHA-256 hash of a string. Example: SELECT sha256('Hello, World');",
    insertText: 'sha256',
    detail: 'sha256(string) → varbinary',
  },
  {
    label: 'sha512',
    documentation:
      "Returns the SHA-512 hash of a string. Example: SELECT sha512('Hello, World');",
    insertText: 'sha512',
    detail: 'sha512(string) → varbinary',
  },
  {
    label: 'shuffle',
    documentation:
      'Shuffles the elements of an array. Example: SELECT shuffle(array[1, 2, 3]);',
    insertText: 'shuffle',
    detail: 'shuffle(array) → array',
  },
  {
    label: 'sign',
    documentation: 'Returns the sign of a number. Example: SELECT sign(-1);',
    insertText: 'sign',
    detail: 'sign(x) → bigint',
  },
  {
    label: 'similarity',
    documentation:
      "Returns the similarity between two strings. Example: SELECT similarity('Hello', 'Hallo');",
    insertText: 'similarity',
    detail: 'similarity(string1, string2) → double',
  },
  {
    label: 'sin',
    documentation:
      'Returns the sine of a number. Example: SELECT sin(3.14159 / 2);',
    insertText: 'sin',
    detail: 'sin(x) → double',
  },
  {
    label: 'sinh',
    documentation:
      'Returns the hyperbolic sine of a number. Example: SELECT sinh(0);',
    insertText: 'sinh',
    detail: 'sinh(x) → double',
  },
  {
    label: 'skewness',
    documentation:
      'Returns the skewness of a set of values. Example: SELECT skewness(column) FROM table;',
    insertText: 'skewness',
    detail: 'skewness(x) → double',
  },
  {
    label: 'slice',
    documentation:
      'Returns a slice of an array. Example: SELECT slice(array[1, 2, 3, 4], 2, 2);',
    insertText: 'slice',
    detail: 'slice(array, start, length) → array',
  },
  {
    label: 'sort_array',
    documentation:
      'Sorts an array. Example: SELECT sort_array(array[3, 2, 1]);',
    insertText: 'sort_array',
    detail: 'sort_array(array) → array',
  },
  {
    label: 'soundex',
    documentation:
      "Returns the soundex code of a string. Example: SELECT soundex('Hello');",
    insertText: 'soundex',
    detail: 'soundex(string) → varchar',
  },
  {
    label: 'split',
    documentation:
      "Splits a string into an array using a delimiter. Example: SELECT split('Hello, World', ',');",
    insertText: 'split',
    detail: 'split(string, delimiter) → array',
  },
  {
    label: 'sqrt',
    documentation:
      'Returns the square root of a number. Example: SELECT sqrt(4);',
    insertText: 'sqrt',
    detail: 'sqrt(x) → double',
  },
  {
    label: 'stddev',
    documentation:
      'Returns the standard deviation of a set of values. Example: SELECT stddev(column) FROM table;',
    insertText: 'stddev',
    detail: 'stddev(x) → double',
  },
  {
    label: 'stddev_pop',
    documentation:
      'Returns the population standard deviation of a set of values. Example: SELECT stddev_pop(column) FROM table;',
    insertText: 'stddev_pop',
    detail: 'stddev_pop(x) → double',
  },
  {
    label: 'stddev_samp',
    documentation:
      'Returns the sample standard deviation of a set of values. Example: SELECT stddev_samp(column) FROM table;',
    insertText: 'stddev_samp',
    detail: 'stddev_samp(x) → double',
  },
  {
    label: 'str_to_map',
    documentation:
      "Converts a string to a map. Example: SELECT str_to_map('key1=value1&key2=value2', '&', '=');",
    insertText: 'str_to_map',
    detail: 'str_to_map(string, delimiter1, delimiter2) → map',
  },
  {
    label: 'strftime',
    documentation:
      "Formats a timestamp as a string. Example: SELECT strftime(timestamp '2023-01-01 00:00:00', '%Y-%m-%d');",
    insertText: 'strftime',
    detail: 'strftime(timestamp, format) → varchar',
  },
  {
    label: 'strptime',
    documentation:
      "Parses a string into a timestamp using a format. Example: SELECT strptime('2023-01-01', '%Y-%m-%d');",
    insertText: 'strptime',
    detail: 'strptime(string, format) → timestamp',
  },
  {
    label: 'substr',
    documentation:
      "Returns a substring of a string. Example: SELECT substr('Hello, World', 1, 5);",
    insertText: 'substr',
    detail: 'substr(string, start, length) → varchar',
  },
  {
    label: 'tan',
    documentation:
      'Returns the tangent of a number. Example: SELECT tan(3.14159 / 4);',
    insertText: 'tan',
    detail: 'tan(x) → double',
  },
  {
    label: 'tanh',
    documentation:
      'Returns the hyperbolic tangent of a number. Example: SELECT tanh(0);',
    insertText: 'tanh',
    detail: 'tanh(x) → double',
  },
  {
    label: 'timezone',
    documentation:
      "Returns the timezone of a timestamp. Example: SELECT timezone(timestamp '2023-01-01 00:00:00');",
    insertText: 'timezone',
    detail: 'timezone(x) → varchar',
  },
  {
    label: 'to_base64',
    documentation:
      "Encodes a string to base64. Example: SELECT to_base64('Hello, World');",
    insertText: 'to_base64',
    detail: 'to_base64(string) → varchar',
  },
  {
    label: 'to_char',
    documentation:
      "Converts a timestamp to a string. Example: SELECT to_char(timestamp '2023-01-01 00:00:00', 'YYYY-MM-DD');",
    insertText: 'to_char',
    detail: 'to_char(timestamp, format) → varchar',
  },
  {
    label: 'to_date',
    documentation:
      "Converts a string to a date. Example: SELECT to_date('2023-01-01', 'YYYY-MM-DD');",
    insertText: 'to_date',
    detail: 'to_date(string, format) → date',
  },
  {
    label: 'to_hex',
    documentation:
      'Converts a number to a hexadecimal string. Example: SELECT to_hex(255);',
    insertText: 'to_hex',
    detail: 'to_hex(x) → varchar',
  },
  {
    label: 'to_iso8601',
    documentation:
      "Converts a timestamp to an ISO 8601 string. Example: SELECT to_iso8601(timestamp '2023-01-01 00:00:00');",
    insertText: 'to_iso8601',
    detail: 'to_iso8601(timestamp) → varchar',
  },
  {
    label: 'to_unixtime',
    documentation:
      "Converts a timestamp to a Unix timestamp. Example: SELECT to_unixtime(timestamp '2023-01-01 00:00:00');",
    insertText: 'to_unixtime',
    detail: 'to_unixtime(timestamp) → double',
  },
  {
    label: 'to_utf8',
    documentation:
      "Converts a string to a UTF-8 byte array. Example: SELECT to_utf8('Hello, World');",
    insertText: 'to_utf8',
    detail: 'to_utf8(string) → varbinary',
  },
  {
    label: 'transform',
    documentation:
      'Transforms an array using a function. Example: SELECT transform(array[1, 2, 3], x -> x * 2);',
    insertText: 'transform',
    detail: 'transform(array, function) → array',
  },
  {
    label: 'typeof',
    documentation:
      'Returns the type of a value. Example: SELECT typeof(column) FROM table;',
    insertText: 'typeof',
    detail: 'typeof(x) → varchar',
  },
  {
    label: 'ucase',
    documentation:
      "Converts a string to uppercase. Example: SELECT ucase('Hello, World');",
    insertText: 'ucase',
    detail: 'ucase(string) → varchar',
  },
  {
    label: 'unbase64',
    documentation:
      "Decodes a base64 string. Example: SELECT unbase64('SGVsbG8sIFdvcmxk');",
    insertText: 'unbase64',
    detail: 'unbase64(string) → varbinary',
  },
  {
    label: 'unicode',
    documentation:
      "Returns the Unicode code point of the first character of a string. Example: SELECT unicode('A');",
    insertText: 'unicode',
    detail: 'unicode(string) → bigint',
  },
  {
    label: 'unix_timestamp',
    documentation:
      "Returns the Unix timestamp of a timestamp. Example: SELECT unix_timestamp(timestamp '2023-01-01 00:00:00');",
    insertText: 'unix_timestamp',
    detail: 'unix_timestamp(x) → bigint',
  },
  {
    label: 'unnest',
    documentation:
      'Unnests an array into a table. Example: SELECT unnest(array[1, 2, 3]);',
    insertText: 'unnest',
    detail: 'unnest(array) → table',
  },
  {
    label: 'variance',
    documentation:
      'Returns the variance of a set of values. Example: SELECT variance(column) FROM table;',
    insertText: 'variance',
    detail: 'variance(x) → double',
  },
  {
    label: 'varpop',
    documentation:
      'Returns the population variance of a set of values. Example: SELECT varpop(column) FROM table;',
    insertText: 'varpop',
    detail: 'varpop(x) → double',
  },
  {
    label: 'varsamp',
    documentation:
      'Returns the sample variance of a set of values. Example: SELECT varsamp(column) FROM table;',
    insertText: 'varsamp',
    detail: 'varsamp(x) → double',
  },
  {
    label: 'week',
    documentation:
      "Returns the week of the year from a timestamp. Example: SELECT week(timestamp '2023-01-01 00:00:00');",
    insertText: 'week',
    detail: 'week(x) → bigint',
  },
  {
    label: 'weekday',
    documentation:
      "Returns the day of the week from a timestamp. Example: SELECT weekday(timestamp '2023-01-01 00:00:00');",
    insertText: 'weekday',
    detail: 'weekday(x) → bigint',
  },
  {
    label: 'years',
    documentation:
      "Returns the year from a timestamp. Example: SELECT years(timestamp '2023-01-01 00:00:00');",
    insertText: 'years',
    detail: 'years(x) → bigint',
  },
];
